import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Spinner,
  InputGroup,
  Accordion,
  Modal,
  Alert,
} from "react-bootstrap";
import { Autocomplete, Box, Chip, TextField, Paper, Tooltip } from "@mui/material";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
// import ProductAndServiceSection from "../Enquiry/DynamicProductAndServiceForm";

import AgentDetailsSection from "../../../../Common/DynamicComponentsForEnquiryQuotationSalesOrder/AgentDetailsSection";
import AssignedMemberSection, {
  Member,
} from "../../../../Common/DynamicComponentsForEnquiryQuotationSalesOrder/AssignedMemberSection";
import BillingFromAddress from "../../../../Common/DynamicComponentsForEnquiryQuotationSalesOrder/BillingFromAddress";
import { AppDispatch } from "index";
import {
  fetchProductQuotationById,
  fetchServiceQuotationById,
  fetchProductQuotationDynamicDropdown,
} from "slices/quotation/thunk";
import { MecordColors } from "../../../../Constants/Color";
import { formatIndianAmount } from "helpers/formatIndianAmount";
import { autocompleteDropdownStyles } from "Constants/Style";
import { Agent } from "Common/CommonEnquiryData/EnquiryType";
import { useQuotationCalculations } from "Common/Hooks/UseCalculationForQuotationAndSalesOrder";
import {
  AssignedMemberDetailRetrive,
  initialPBGDetail,
  initialSalesOrderData,
  SalesOrderDataRetrive,
} from "Common/CommonEnquiryData/SalesOrderRetriveProductType";
import { buildSalesOrderPayload } from "Common/CommonEnquiryData/SalesOrderProductPayloadType";
import FormBreadcrumb from "Common/Components/FormBreadcrumb/FormBreadcrumb";
import * as Yup from "yup";
import { useFormik, FormikProvider } from "formik";
import FileUpload from "Common/Components/FileUpload.tsx/FileUpload";
import CurrencyExchangeSection from "Common/CurrencyExchangeSection/CurrencyExchangeSection";
import { Axios } from "api/axios";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import LoadingSpinner from "Common/Components/LoaderErrorWrapper/LoadingSpinner";
import ProductAndServiceSection from "./DynamicProductAndServiceForm";
import FormActionButtons from "pages/QuotationV2/Form/Components/FormActionButtons";
import CompanyFormModal from "../../components/CompanyFormModal";
import { fetchCompanyByDropDown } from "slices/Masters/company/thunk";
import { createSelector } from "reselect";
import ProductFormModal from "../../components/ProductFormModal";
import {
  fetchCategories,
  fetchSubcategories,
  fetchMakes,
  fetchModels,
} from "slices/enquiry/thunk";
import ServiceFormModal from "../../components/ServiceFormModal";
import AddressFormModal from "pages/Enquiry/Components/AddressFormModal";
import { fetchAllUsersDropdown } from "slices/UserManagement/user/thunk";
import { fetchProductSalesOrderById, updateProductSalesOrder } from "slices/sales_order/thunk";
import { fetchCurrencyByDropDown } from "slices/Masters/currency/thunk";
import { fetchGstByDropDown } from "slices/Masters/gst/thunk";
import { fetchProductEnquiryDropdown } from "slices/enquiry/thunk";
import { fetchProductsAndServicesByDropDown } from "slices/Masters/productsandservices/thunk";
import {
  // fetchAllDropdowns,
  fetchOrganisations,
} from "slices/UserManagement/organisation/thunk";
import TermsConditionsSection from "pages/QuotationV2/Form/Sections/TermsConditionsSection";
import RetentionDetails from "../../components/RetentaionDetails";
import ScheduleFollowUp from "../../components/ScheduleFollowUp";
import AddTagsForSalesOrder from "../../components/AddTagsForSalesOrder";
// Re-define component props, referencing new types
import PageContainer from "Common/Components/PageContainer/PageContainer";
import AddCustomerModal from "pages/QuotationV2/Form/Components/AddCustomerModal";
import AddProductModal from "pages/QuotationV2/Form/Components/AddProductModal";
import { checkDomainOfScale } from "recharts/types/util/ChartUtils";
import { useScrollToFormikError } from "hooks/useScrollToFormikError";

// Helper function to convert UTC date to local date string (YYYY-MM-DD format)
// Backend returns UTC dates, we need to convert to local for display
const formatDateForInput = (dateString: string | null | undefined): string => {
  if (!dateString) return "";
  try {
    // Parse UTC date string
    const utcDate = new Date(dateString);
    if (isNaN(utcDate.getTime())) return "";

    // Get local date components
    const year = utcDate.getFullYear();
    const month = String(utcDate.getMonth() + 1).padStart(2, "0");
    const day = String(utcDate.getDate()).padStart(2, "0");

    // Return in YYYY-MM-DD format (for HTML date input)
    return `${year}-${month}-${day}`;
  } catch {
    return "";
  }
};

// Helper function to get initials from first and last name
const getInitials = (firstName: string, lastName: string): string => {
  const first = firstName?.charAt(0) || "";
  const last = lastName?.charAt(0) || "";
  return (first + last).toUpperCase();
};

// Helper function to format full address with city, country, and pincode
const formatFullAddress = (addressObj: any): string => {
  if (!addressObj) return "";
  
  const parts = [];
  if (addressObj.address) parts.push(addressObj.address);
  if (addressObj.city) parts.push(addressObj.city);
  if (addressObj.country) parts.push(addressObj.country);
  if (addressObj.pin_code || addressObj.pincode) parts.push(addressObj.pin_code || addressObj.pincode);
  
  return parts.length > 0 ? parts.join(", ") : "";
};

// Helper function to transform terms and conditions - group by type to handle multiple options per type
const transformTermsAndConditions = (terms_and_conditions: any): any[] => {
  if (!terms_and_conditions) return [];

  // Handle object (non-array) case
  let termsArray: any[] = [];
  if (Array.isArray(terms_and_conditions)) {
    termsArray = terms_and_conditions;
  } else if (typeof terms_and_conditions === "object") {
    termsArray = Object.values(terms_and_conditions);
  } else {
    return [];
  }

  if (termsArray.length === 0) return [];

  // Check if already in form format (has description with newlines or id field)
  const isFormFormat = termsArray.some((term: any) =>
    (term.description && term.description.includes("\n")) || term.id
  );

  if (isFormFormat) {
    // Already in form format - group by type and merge options
    const groupedByType: Record<string, string[]> = {};
    termsArray.forEach((term: any) => {
      if (term.type) {
        if (!groupedByType[term.type]) {
          groupedByType[term.type] = [];
        }
        // Extract options from description (newline-separated) or from option/options field
        if (term.description && term.description.includes("\n")) {
          const options = term.description.split("\n").filter((opt: string) => opt.trim() !== "");
          options.forEach((opt: string) => {
            if (!groupedByType[term.type].includes(opt.trim())) {
              groupedByType[term.type].push(opt.trim());
            }
          });
        } else if (term.description) {
          const opt = term.description.trim();
          if (opt && !groupedByType[term.type].includes(opt)) {
            groupedByType[term.type].push(opt);
          }
        } else if (term.option) {
          const opt = term.option.trim();
          if (opt && !groupedByType[term.type].includes(opt)) {
            groupedByType[term.type].push(opt);
          }
        } else if (term.options) {
          const opt = typeof term.options === 'string' ? term.options.trim() : String(term.options).trim();
          if (opt && !groupedByType[term.type].includes(opt)) {
            groupedByType[term.type].push(opt);
          }
        }
      }
    });

    return Object.entries(groupedByType).map(
      ([type, options], index) => ({
        id: `term-${index}-${Date.now()}-${Math.random()}`,
        type: type,
        option: options[0] || "",
        description: options.join("\n"),
      })
    );
  } else {
    // Backend format: array of {type, options} - group by type
    const groupedByType: Record<string, string[]> = {};
    termsArray.forEach((term: any) => {
      if (term.type && term.options) {
        if (!groupedByType[term.type]) {
          groupedByType[term.type] = [];
        }
        const option = typeof term.options === 'string' ? term.options.trim() : String(term.options).trim();
        if (option && !groupedByType[term.type].includes(option)) {
          groupedByType[term.type].push(option);
        }
      }
    });

    return Object.entries(groupedByType).map(
      ([type, options], index) => ({
        id: `term-${index}-${Date.now()}-${Math.random()}`,
        type: type,
        option: options[0] || "",
        description: options.join("\n"),
      })
    );
  }
};

// Helper function to transform backend response to formik format
const transformBackendDataToFormData = (backendData: any): SalesOrderDataRetrive => {
  // console.log("Transforming backend data for ProductSalesOrderEditForm:", backendData);

  return {
    id: backendData.sales_order_product_id,
    created_at: backendData.created_at,
    updated_at: backendData.updated_at,
    created_by_user: backendData.created_by_user,
    updated_by_user: backendData.updated_by_user,
    contact_person_phone_no: backendData.customer_details?.contact_person_phone_no || "",
    members: (backendData.assigned_members || []).map((member: any) => ({
      ...member,
      id: member.user_id || member.id,
      fullname:
        member.fullname ||
        (member.first_name || member.last_name
          ? `${member.first_name || ""} ${member.last_name || ""}`.trim()
          : "") ||
        member.username ||
        "",
      username: member.username || member.email || "",
    })),

    assigned_member_details: backendData.assigned_members?.map((member: any) => ({
      user: member.user_id,
      username: member.username,
      first_name: member.first_name,
      last_name: member.last_name,
      email: member.email,
      designation: member.user_type || "", // Using user_type as designation since designation field is not present
      address: member.address || "",
      city: member.city || "",
      state: member.state || "",
      country: member.country || "",
      pin_code: member.pin_code || "",
      mobile_number: member.phone_number || "", // Changed from mobile_number to phone_number
      user_type: member.user_type,
    })) || [],
    emd_applicable: backendData.emd_applicable || false,
    mode_of_emd: backendData.mode_of_emd || "",
    emd: backendData.emd || "",
    emd_amount: backendData.emd_amount || "",
    item_details: (backendData.sales_order_product_items || [])?.map((product: any) => ({

      id: product.sales_order_product_item_id,
      item: product.product_id,
      item_name: product.product_name,
      product_name: product.product_name,
      category: product.category_name, // Will need to fetch category ID if needed
      category_name: product.category_name,
      sub_category: product.sub_category_name, // Will need to fetch sub_category ID if needed
      sub_category_name: product.sub_category_name,
      product_code: product.product_code || "",
      make: product.make_name, // Will need to fetch make ID if needed
      make_name: product.make_name,
      model: product.model_name, // Will need to fetch model ID if needed
      model_name: product.model_name,
      unit: product.unit_name, // Will need to fetch unit ID if needed
      unit_name: product.unit_name,
      unit_price: product.unit_price,
      quantity: product.product_quantity || 0,
      // Normalize discount_type: backend may send "percentage", but form uses "percentage" or "%"
      discount_type: (() => {
        const dt = product.discount_type || "none";
        // Normalize "percentage" to "percentage" (form uses "percentage" as value)
        if (dt === "%" || dt === "percentage" || dt?.toLowerCase() === "percent") {
          return "percentage";
        }
        return dt;
      })(),
      // Calculate discount_amount and discount_value correctly based on discount_type and net_value
      // If we have net_value, we can back-calculate the discount_amount
      ...((): { discount_value: number; discount_percent: number | null; discount_amount: number } => {
        const discountType = product.discount_type || "none";
        const discountValueFromBackend = Number(product.discount_value) || 0;
        const unitPrice = Number(product.unit_price) || 0;
        const qty = Number(product.product_quantity) || 0;

        // Use gross_value from backend if available (especially important for foreign currencies)
        // Otherwise calculate from unit_price * qty
        const grossValueFromBackend = Number(product.gross_value) || 0;
        const grossValue = grossValueFromBackend > 0
          ? grossValueFromBackend
          : (unitPrice * qty);

        const netValueFromBackend = Number(product.product_net_total) || 0;

        // If we have net_value, calculate discount_amount from it
        const calculatedDiscountAmount = grossValue > 0 ? grossValue - netValueFromBackend : 0;

        // Check if discount_type is percentage (could be "%" or "percentage")
        const isPercentageDiscount = discountType === "%" || discountType === "percentage" || discountType?.toLowerCase() === "percent";

        if (isPercentageDiscount) {
          // For percentage discount, discount_value from backend is the percentage
          // Use discount_value directly if it's <= 100, otherwise calculate from discount_amount
          let discountPercent = 0;
          if (discountValueFromBackend > 0 && discountValueFromBackend <= 100) {
            // Backend sent percentage directly
            discountPercent = discountValueFromBackend;
          } else if (calculatedDiscountAmount > 0 && grossValue > 0) {
            // Calculate percentage from discount_amount
            discountPercent = Math.round((calculatedDiscountAmount / grossValue) * 100 * 100) / 100;
          } else {
            discountPercent = discountValueFromBackend > 100 ? 100 : discountValueFromBackend;
          }

          // Calculate discount_amount from percentage
          const discountAmount = grossValue > 0
            ? (calculatedDiscountAmount > 0 ? calculatedDiscountAmount : (grossValue * discountPercent / 100))
            : 0;

          return {
            discount_value: discountPercent,
            discount_percent: discountPercent,
            discount_amount: discountAmount,
          };
        } else if (discountType && discountType !== "none") {
          // For currency discount, discount_value is the amount
          const discountAmount = calculatedDiscountAmount > 0
            ? calculatedDiscountAmount
            : (discountValueFromBackend > grossValue ? grossValue : discountValueFromBackend);

          return {
            discount_value: discountAmount,
            discount_percent: null,
            discount_amount: discountAmount,
          };
        }

        return {
          discount_value: 0,
          discount_percent: null,
          discount_amount: 0,
        };
      })(),
      net_value: product.product_net_total,
      gst_percent: product.gst_percentage,
      cgst_percent: product.cgst_percentage || 0,
      igst_percent: product.igst_percentage || 0,
      sgst_percent: product.sgst_percentage || 0,
      gst_amount: product.gst_value || 0,
      total_amount: product.product_total,
      total_price: product.product_total,
      is_serviceable: product.serviceable || false,
      remark: product.remark || "",
      product_sku: product.product_sku || "",
      product_type: product.product_type || [],
      hsn_code: product.hsn_code || "",
      serial_number: product.serial_number || null,
      shipping_address_id: product.shipping_address?.shipping_address_id || null,
      shipping_address: product.shipping_address || null,
      currency_applicable: backendData.currency_applicable || false,
      exchange_rate: backendData.currency_rate_in_inr || "1",
      currency_code: backendData.currency_code || "INR",
      currency_symbol: backendData.currency_symbol || "₹",
      // Include gross_value and rate_in_currency from backend (important for foreign currencies)
      gross_value: product.gross_value || "",
      rate_in_currency: product.rate_in_currency || "",
      // Handle warranty fields with correct spelling from backend
      warranty_in_months: product.warrenty_in_months || "",
      warranty_date: formatDateForInput(product.warrenty_date || product.warranty_date || ""),
      // Store original GST percent for recalculation
      original_gst_percent: product.gst_percentage || 0,
      // Include availability from backend, default to "In Stock" if not present
      availability: product.item_availability || "In Stock",
      prod_description: product.prod_description ?? "",
      additional_details: product.additional_details ?? "",
    })) || [],
    pbg_details: {
      id: backendData.pbg_id || "",
      created_at: backendData.created_at || "",
      updated_at: backendData.updated_at || "",
      created_by_user: backendData.created_by_user || "",
      updated_by_user: backendData.updated_by_user || "",
      sales_order_type: backendData.sales_order_type || "product",
      product_sales_order: null,
      service_sales_order: null,
      created_by: backendData.created_by || "",
      updated_by: backendData.updated_by || "",
      is_active: backendData.is_active !== undefined ? backendData.is_active : true,
      is_deleted: backendData.is_deleted !== undefined ? backendData.is_deleted : false,
      pbg_required: backendData.pbg_applicable || false,
      pbg_number: backendData.pbg_number || "",
      pbg_date: formatDateForInput(backendData.pbg_date),
      bank_name: backendData.bank_name || "",
      amount: backendData.pbg_amount || "",
      validity: formatDateForInput(backendData.pbg_validity),
      pbg_status: backendData.pbg_status || "",
      next_follow_up_date: (() => {
        // Extract PBG follow-up date from sales_order_follow_ups
        const pbgFollowUp = backendData.sales_order_follow_ups?.find(
          (followUp: any) => followUp.follow_up_category === "Pbg"
        );
        return pbgFollowUp ? formatDateForInput(pbgFollowUp.next_follow_up_date) : "";
      })(),
      upload_document:  [] as any, // Array of URLs
    },
    attachments:  [], // Array of URLs
    company: {
      id: backendData.customer_details?.company_id,
      company_id: backendData.customer_details?.company_id,
      company_name: backendData.customer_details?.company_name,
      industry: backendData.customer_details?.industry,
      gstin: backendData.customer_details?.gstin,
      gst_type: backendData.customer_details?.gst_type,
      phone_number: backendData.customer_details?.phone_number,
      email: backendData.customer_details?.email,
      address: backendData.customer_details?.address,
      contact_details: backendData.customer_details?.contact_details || [],
      billing_address: backendData.customer_details?.billing_address ? {
        address: backendData.customer_details.billing_address.address || "",
        city: backendData.customer_details.billing_address.city || "",
        state: backendData.customer_details.billing_address.state || "",
        country: backendData.customer_details.billing_address.country || "",
        pin_code: backendData.customer_details.billing_address.pincode || backendData.customer_details.billing_address.pin_code || "",
        phone_number: backendData.customer_details.billing_address.phone_number || "",
      } : {
        address: "",
        city: "",
        state: "",
        country: "",
        pin_code: "",
        phone_number: "",
      },
      shipping_address: backendData.customer_details?.shipping_address || [],
      customer_po_number: backendData.customer_details?.customer_po_number || backendData.customer_po_number || "",
      customer_po_date: formatDateForInput(backendData.customer_details?.customer_po_date || backendData.customer_po_date),
      customer_po_document_url:  [] as any,
      sr_no: backendData.customer_details?.sr_no,
    },
    billing_address: backendData.customer_details?.billing_address ? {
      address: backendData.customer_details.billing_address.address || "",
      city: backendData.customer_details.billing_address.city || "",
      state: backendData.customer_details.billing_address.state || "",
      country: backendData.customer_details.billing_address.country || "",
      pin_code: backendData.customer_details.billing_address.pincode || backendData.customer_details.billing_address.pin_code || "",
      phone_number: backendData.customer_details.billing_address.phone_number || "",
    } : {
      address: "",
      city: "",
      state: "",
      country: "",
      pin_code: "",
      phone_number: "",
    },
    shipping_address: backendData.customer_details?.shipping_address || [],
    quotation_reference: backendData.quotation_number || "",
    quotation_number: backendData.quotation_number || "",
    quotation: backendData.quotation_product_id || "",
    enquiry_reference: backendData.enquiry_number || "",
    enquiry_number: backendData.enquiry_number || "",
    reference_number: backendData.reference_number || "",
    enquiry: backendData.enquiry_product_id || "",
    bill_to_address: backendData.bill_to,
    bill_from_address: backendData.bill_from,
    bill_to: backendData.bill_to,
    bill_from: backendData.bill_from,
    created_by: backendData.created_by,
    updated_by: backendData.updated_by,
    is_active: backendData.is_active,
    is_deleted: backendData.is_deleted,
    sales_order_stage: backendData.sales_order_stage,
    sales_order_number: backendData.sales_order_number,
    sales_order_date: formatDateForInput(backendData.sales_order_date),
    valid_until_date: formatDateForInput(backendData.valid_until_date),
    initiated_by: backendData.initiated_by,
    industry: backendData.customer_details?.industry,
    contactPerson: {},
    customer_po_document_url: backendData.customer_details?.customer_po_documents || [],
    contact_person_name: backendData.customer_details?.contact_details?.[0]?.name || "",
    contact_person_designation: backendData.customer_details?.contact_details?.[0]?.designation || "",
    contact_person_email: backendData.customer_details?.contact_person_email || "",
    // Map contact_details to contactPersonArray for the form
    contactPersonArray: backendData.customer_details?.contact_details?.map((contact: any) => ({
      id: contact.contact_id || "",
      contact_person_name: contact.name || "",
      contact_person_email: contact.email || "",
      contact_person_phone_no: contact.phone_number || "",
      contact_person_designation: contact.designation || "",
      contact_person_department: contact.department || "",
    })) || [],
    agent_name: backendData.agent_name || "",
    subtotal_before_discount: backendData.sub_total_before_discount || "0",
    total_item_discounts: backendData.total_discount_value || "0",
    net_taxable_value: backendData.total_net_value || "0",
    total_gst: backendData.total_gst_value || "0",
    total_amount: backendData.grand_total_amount || "0",
    terms_and_conditions: transformTermsAndConditions(backendData.terms_and_conditions || []),
    retention_details: {
      retention_applicable: backendData.retention_applicable || false,
      retentionType: backendData.retention_type || "",
      percentage: backendData.retention_percentage || "",
      retentionAmount: backendData.retention_amount || "",
      followUpDate: (() => {
        // Extract retention follow-up date from sales_order_follow_ups
        const retentionFollowUp = backendData.sales_order_follow_ups?.find(
          (followUp: any) => followUp.follow_up_category === "Retention"
        );
        return retentionFollowUp ? formatDateForInput(retentionFollowUp.next_follow_up_date) : "";
      })(),
    },
    notes: backendData.notes || "",
    next_follow_up_date: (() => {
      // Extract general/other follow-up date from sales_order_follow_ups
      const otherFollowUp = backendData.sales_order_follow_ups?.find(
        (followUp: any) => followUp.follow_up_category === "Other"
      );
      return otherFollowUp ? formatDateForInput(otherFollowUp.next_follow_up_date) : "";
    })(),
    follow_up_remarks: (() => {
      // Extract general/other follow-up remarks from sales_order_follow_ups
      const otherFollowUp = backendData.sales_order_follow_ups?.find(
        (followUp: any) => followUp.follow_up_category === "Other"
      );
      return otherFollowUp ? otherFollowUp.follow_up_remarks || "" : "";
    })(),
    status: backendData.sales_order_status || backendData.status,
    customer_po_number: backendData.customer_details?.customer_po_number || "",
    customer_po_date: formatDateForInput(backendData.customer_details?.customer_po_date),
    currency_code: backendData.currency_code || backendData.currency_details?.currency_code || "INR",
    currency_symbol: backendData.currency_symbol || "₹",
    exchange_rate: backendData.currency_rate_in_inr || "1",
    currency_applicable:
      backendData.currency_applicable ??
      !!(
        backendData.currency_code &&
        backendData.currency_code !== "INR" &&
        backendData.currency_code !== "IND"
      ),
    composition_gst: false,
    select_composition_gst: "",

    // Tags at sales order level
    tags: Array.isArray(backendData.tags)
      ? backendData.tags
          .map((t: any) => String(t).trim())
          .filter((t: string) => t.length > 0)
      : [],
    payment_terms: "",
    payment_terms_amount: backendData.payment_terms_amount != null ? String(backendData.payment_terms_amount) : "",
    advance_payment: "",
    pending_payment: "",
    next_credit_schedule: "",
    payment_reminder: "",
    inspection_applicable:
      backendData.inspection_applicable ??
      !!(backendData.inspection || backendData.installation),
    inspection: backendData.inspection || "Not Applicable",
    inspection_date: formatDateForInput(backendData.inspection_date || ""),
    installation: backendData.installation || "Not Applicable",
    installation_date: formatDateForInput(backendData.installation_date || ""),
    technicians: [],
    // Missing properties from SalesOrderDataRetrive interface
    company_name: backendData.customer_details?.company_name || "",
    company_email: backendData.customer_details?.email || "",
    contact: backendData.customer_details?.contact_details || [],
    organization_billing_address: {},
  };
  // console.log("transfor medData in ProductSalesOrderEditForm =>", transformedData);  
};

const ProductSalesOrderEditForm = () => {
  const dispatch = useDispatch<any>();

  const navigate = useNavigate();
  const location = useLocation();

  // Extract tab from URL path (e.g., /sales_order/product/draft/edit/123 -> "draft")
  // or /sales_order/product/sales-order-log/edit/123 -> "sales-order-log"
  // or /sales_order/product/edit/123 -> try to get from referrer or location.state
  const getBackPath = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    // Expected structure: sales_order, product, tab, edit, id (if tab is in path)
    // OR: sales_order, product, edit, id (if tab is not in path)
    const productIndex = pathSegments.findIndex(seg => seg === 'product');
    if (productIndex === -1) {
      // Fallback if product not found in path
      return `/sales_order/product/sales_order_log`;
    }

    // Check if tab is in the path (structure: sales_order, product, tab, edit, id)
    const segmentAfterProduct = pathSegments[productIndex + 1];
    let tab: string | null = null;

    // If the segment after 'product' is 'edit', then tab is not in the path
    // Otherwise, it should be the tab
    if (segmentAfterProduct === 'edit') {
      // Tab is not in path, try to get from location.state or referrer
      if (location.state && (location.state as any).tab) {
        tab = (location.state as any).tab;
      } else if (document.referrer) {
        // Try to extract tab from referrer URL
        const referrerSegments = document.referrer.split('/').filter(Boolean);
        const referrerProductIndex = referrerSegments.findIndex(seg => seg === 'product');
        if (referrerProductIndex !== -1) {
          const referrerTab = referrerSegments[referrerProductIndex + 1];
          if (referrerTab && ['draft', 'sales-order-log', 'sales_order_log', 'junk'].includes(referrerTab)) {
            tab = referrerTab;
          }
        }
      }
    } else {
      // Tab is in the path
      tab = segmentAfterProduct;
    }

    // Map tab to the correct route (handle both hyphen and underscore variants)
    if (tab === 'draft') {
      return `/sales_order/product/draft`;
    } else if (tab === 'sales-order-log' || tab === 'sales_order_log') {
      return `/sales_order/product/sales_order_log`;
    } else if (tab === 'junk') {
      return `/sales_order/product/junk`;
    }
    // Default fallback
    return `/sales_order/product/sales_order_log`;
  };

  const [loading, setLoading] = useState(false); // For data loading
  const [loadingError, setLoadingError] = useState<string | null>(null); // For data loading error
  const [saving, setSaving] = useState(false); // For Save button
  const [savingDraft, setSavingDraft] = useState(false); // For Save and Draft button
  const [validationAttemptCount, setValidationAttemptCount] = useState(0);

  const { id } = useParams<{ id: string }>();

  const [items, setItems] = useState<any[]>([]);
  const [shippingAddresses, setShippingAddresses] = useState<
    {
      id: string;
      address: string;
      state?: string;
      city?: string;
      pin_code?: string;
    }[]
  >([]);


  // Autocomplete option states (MUI requires objects)
  const [pbgStatusOptions] = useState(["Received", "Pending", "Waived"]);
  const [statusOptions] = useState(["In Progress", "Completed", "Cancelled"]);
  const [selectedQuotation, setSelectedQuotation] = useState<any>(null);
  const [generalFile, setGeneralFile] = useState<File | null>(null);
  const isUserSelectingQuotation = useRef(false);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedMemberIds, setSelectedMemberIds] = useState<string[]>([]);
  const productFormRef = useRef<any>(null);





  const retentionTypeOptions = [
    { label: "Percentage", value: "percentage" },
    { label: "Amount", value: "amount" },
  ];

  const [initialData, setInitialData] = useState<any>(null);
  const [transformedData, setTransformedData] = useState<SalesOrderDataRetrive>({
    ...initialSalesOrderData,
    members: initialSalesOrderData.members || [],
  });

  interface CompositionOption {
    gst_id: string;
    gst_percentage: string;
  }
  const [compositionList, setCompositionList] = useState<CompositionOption[]>(
    []
  );

  const [currencyList, setCurrencyList] =
    useState<{
      label: string;
      value: string;
      currency_id?: string;
      currency_name?: string;
      currency_symbol?: string;
    }[]>([]);

  const [tableExchange, setTableExchange] = useState<string | number>("");
  const [technicianOptions, setTechnicianOptions] = useState<any[]>([]);
  const [companies, setCompanies] = useState<any[]>([]);
  const [quotationRefenrence, setQuotationRefenrence] = useState<any[]>([]);
  const [existingDocuments, setExistingDocuments] = useState<any[]>([]);
  const [existingPbgDocuments, setExistingPbgDocuments] = useState<any[]>([]);
  const [existingPoDocuments, setExistingPoDocuments] = useState<any[]>([]);
  const [enquiryReferences, setEnquiryReferences] = useState<any[]>([]);
  const [organizationsState, setOrganizationsState] = useState<any[]>([]);
  const [membersOptions, setMembersOptions] = useState<any[]>([]);
  // Use a defined set of sources if not dynamically fetched
  const commonSources = [
    "Website",
    "Email",
    "Phone Call",
    "Referral",
    "Internal Reference",
  ];

  // Define type for product sales orders
  const type = "product";

  // Selector for companies
  const selectCompanyData = createSelector(
    (state: any) => state.Company,
    (company) => ({ companiesData: company.companyList || [] })
  );
  const { companiesData } = useSelector(selectCompanyData);

  // Selector for item dropdowns (Categories, Makes, Models)
  const selectItemDropdowns = createSelector(
    (state: any) => state.Enquiry,
    (enquiry) => ({
      categories: enquiry.categories || [],
      sub_categories: enquiry.subCategories || [],
      makes: enquiry.makes || [],
      models: enquiry.models || [],
      products: enquiry.products || [],
    })
  );

  const { categories, sub_categories, makes, models, products } =
    useSelector(selectItemDropdowns);

  // Define onSave function
  const onSave = async (payload: any, action: "draft" | "save") => {
    try {
      if (id) {
        await dispatch(updateProductSalesOrder({ id, payload })).unwrap();
        toast.success("Sales Order updated successfully");
      }
    } catch (error: any) {
      // Extract error message from various possible error structures
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data ||
        error?.message ||
        (typeof error === 'string' ? error : "Failed to update sales order");

      throw new Error(errorMessage);
    }
  };

  // Define onQuotationSelect function
  const onQuotationSelect = (quotationId: string) => {
    // Handle quotation selection
    // console.log("Quotation selected:", quotationId);
  };

  // Dynamic Dropdown Fetchers
  const fetchServiceSubcategories = (categoryId: string): void =>
    dispatch(
      fetchSubcategories({ item_type: "product", categoryId: categoryId })
    );

  const fetchServiceMakes = (params: { categoryId: string; subcategoryId: string }): void =>
    dispatch(fetchMakes(params));

  const fetchServiceModels = (params: {
    categoryId: string;
    subcategoryId: string;
    makeId: string;
  }): void => dispatch(fetchModels(params));

  // Currency DropDown
  useEffect(() => {
    const fetchCurrency = async () => {
      try {
        const res = await dispatch(fetchCurrencyByDropDown()).unwrap();
        // console.log("Fetched currency dropdown:", res);
        const resData = res?.data?.data || res?.data || res;
        const mappedCurrencyList = resData.map((item: any) => ({
          label: `${item.currency_name} (${item.currency_code})`,
          value: item.currency_code,
          currency_id: item.currency_id,
          currency_name: item.currency_name,
          currency_symbol: item.currency_symbol,
        }));

        setCurrencyList(mappedCurrencyList);

        // Set currency symbol if currency_code is already set but symbol is missing
        if (formik.values.currency_code && !formik.values.currency_symbol) {
          const selectedCurrency = mappedCurrencyList.find(
            (c: any) => c.value === formik.values.currency_code || c.value === "INR"
          );
          if (selectedCurrency) {
            formik.setFieldValue("currency_symbol", selectedCurrency.currency_symbol);
          } else if (formik.values.currency_code === "INR" || formik.values.currency_code === "IND") {
            formik.setFieldValue("currency_symbol", "₹");
          }
        }
      } catch (err:any) {
        // console.error("Failed to fetch currency list:", err);
        // toast.error(err?.message || err?.error || "Failed to fetch currency list");
      }
    };

    fetchCurrency();
  }, [dispatch]);

  // Fetch GST Dropdown
  useEffect(() => {
    const fetchGST = async () => {
      try {
        const res = await dispatch(fetchGstByDropDown()).unwrap();

        // console.log("Mapped", mappedCurrencyList);
        setCompositionList(res?.data?.data || res.data || res);
      } catch (err) {
        console.error("Failed to fetch currency list:", err);
      }
    };

    fetchGST();
  }, [dispatch]);

  // Update companies state when Redux data changes
  useEffect(() => {
    // console.log("companiesData from Redux:", companiesData);
    // console.log("Setting companies state with:", companiesData);
    setCompanies(companiesData || []);
  }, [companiesData]);

  // Debug companies array
  useEffect(() => {
    // console.log("companies state updated:", companies);
    // console.log("companies length:", companies?.length);
    if (companies && companies.length > 0) {
      // console.log("First company:", companies[0]);
      // console.log("First company name:", companies[0]?.company_name);
    }
  }, [companies]);

  // Fetch Companies and Categories Dropdown
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await dispatch(fetchCompanyByDropDown());
        await dispatch(fetchCategories("products"));
        await dispatch(fetchAllUsersDropdown());
      } catch (err:any) {
        // console.error("Failed to fetch initial data:", err);
        // toast.error(err?.message || err?.error || "Failed to fetch initial data");
      }
    };

    fetchInitialData();
  }, [dispatch]);

  // Fetch Members Dropdown
  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await dispatch(fetchAllUsersDropdown()).unwrap();
        setMembersOptions(res?.data?.data || res.data || res);
      } catch (err:any) {
        // console.error("Failed to fetch Members list:", err);
        // toast.error(err?.message || err?.error || "Failed to fetch Members list");
      }
    };

    fetchMembers();
  }, [dispatch]);

  // Fetch Quotation References for dropdown
  useEffect(() => {
    const fetchQuotationReferences = async () => {
      try {
        const qrefs = await dispatch(
          fetchProductQuotationDynamicDropdown("quotation_number")
        ).unwrap();
        setQuotationRefenrence(qrefs?.data || []);
      } catch (err:any) {
        // console.error("Failed to load quotation references:", err);
        // toast.error(err?.message || err?.error || "Failed to load quotation references");
      }
    };

    fetchQuotationReferences();
  }, [dispatch]);
  // consoel.log("totals")
  // Fetch Organizations
  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const resData = await dispatch(
          fetchOrganisations({
            page: 1,
            pageSize: 100,
            sort: "",
            order: "",
            search: "",
            filters: [],
          })
        ).unwrap();
        setOrganizationsState(resData?.data || []);
      } catch (err:any) {
        // console.error("Failed to fetch organizations:", err);
        // toast.error(err?.message || err?.error || "Failed to fetch organizations");
        setOrganizationsState([]);
      }
    };

    fetchOrganizations();
  }, [dispatch]);

  // Fetch Technician Dropdown
  useEffect(() => {
    const fetchTechnician = async () => {
      try {
        const res = await dispatch(fetchAllUsersDropdown()).unwrap();
        // console.log("Fetched Technician dropdown:", res);
        setTechnicianOptions(res?.data?.data || res.data);
      } catch (err:any) {
        // console.error("Failed to fetch Technician list:", err);
        // toast.error(err?.message || err?.error || "Failed to fetch Technician list");
      }
    };

    fetchTechnician();
  }, [dispatch]);

  const validationSchema = Yup.object().shape({
    // Sales Order Details Validations
    sales_order_date: Yup.date()
      .required("Order date is required")
      .typeError("Invalid order date"),
    valid_until_date: Yup.date()
      .required("Valid Until Date is required")
      .typeError("Invalid Valid Until Date"),
    quotation_number: Yup.string().nullable(),
    quotation: Yup.string().nullable(), // can be null (no need for required)
    initiated_by: Yup.string().required("Initiated by is required"),
    status: Yup.string().nullable(), // dropdown — allow empty
    enquiry_number: Yup.string().nullable(), // autofill — no validation
    enquiry: Yup.string().nullable(), // can be null (no need for required)

    // Customer Details Validations
    company_id: Yup.string().nullable(),
    company_name: Yup.string().required("Company name is required"),
    contactPersonArray: Yup.array()
      .min(1, "At least select one contact person")
      .required("At least select one contact person"),
    industry_name: Yup.string().nullable(),
    company_email: Yup.string().email("Invalid email format").nullable(),
    billing_address: Yup.object().nullable(), // optional, autofill
    bill_from_address: Yup.mixed()
      .required("Bill From address is required")
      .test(
        "is-valid-bill-from-address",
        "Bill From address is required",
        (value: any) => {
          if (!value) return false;
          // If it's a string, check if it's not empty
          if (typeof value === "string") {
            return value.trim() !== "";
          }
          // If it's an object, check if it has org_address or address fields
          if (typeof value === "object" && !Array.isArray(value)) {
            // Check if it's an empty object
            if (Object.keys(value).length === 0) return false;
            // Check if it has org_address or address fields
            return !!(value.org_address || value.address);
          }
          return true;
        }
      ),
    // Contact persons (multiple)
    contact_details: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string().nullable(),
          contact_person_name: Yup.string().required(
            "Contact person name is required"
          ),
          contact_person_email: Yup.string()
            .email("Invalid email format")
            .nullable(),
          contact_person_phone_no: Yup.string().nullable(),
          contact_person_department: Yup.string().nullable(),
          contact_person_designation: Yup.string().nullable(),
        })
      )
      .nullable(),
    // PO fields (top-level)
    customer_po_number: Yup.string().nullable(),
    customer_po_date: Yup.string().nullable(),
    customer_po_document_url: Yup.mixed().nullable(),

    // // Agent Details Validations
    // agent_name: Yup.object()
    //   .shape({
    //     agent_name: Yup.string().nullable(), // can be null
    //   })
    //   .nullable(),

    // Members Staff Validation
    members: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string().required(),
          fullname: Yup.string().required(),
          username: Yup.string().required(),
        })
      )
      .nullable()
      .default([]),

    // PBG Details Validations
    pbg_details: Yup.object({
      pbg_required: Yup.boolean().default(false),

      pbg_number: Yup.string().when("pbg_required", {
        is: true,
        then: (schema) => schema.required("PBG Number is required"),
        otherwise: (schema) => schema,
      }),

      pbg_date: Yup.string().when("pbg_required", {
        is: true,
        then: (schema) => schema.required("PBG Date is required"),
        otherwise: (schema) => schema,
      }),

      bank_name: Yup.string().when("pbg_required", {
        is: true,
        then: (schema) => schema.required("Bank Name is required"),
        otherwise: (schema) => schema,
      }),

      amount: Yup.number().when("pbg_required", {
        is: true,
        then: (schema) =>
          schema
            .required("Amount is required")
            .typeError("Amount must be a number")
            .min(0, "PBG Amount cannot be negative"),
        otherwise: (schema) => schema,
      }),

      validity: Yup.string().when("pbg_required", {
        is: true,
        then: (schema) => schema.required("Validity is required"),
        otherwise: (schema) => schema,
      }),

      pbg_status: Yup.string().when("pbg_required", {
        is: true,
        then: (schema) => schema.required("PBG Status is required"),
        otherwise: (schema) => schema,
      }),

      upload_document: Yup.mixed().nullable(),
    }),

    // Currency & GST/TAXATION
    currency_applicable: Yup.boolean().default(false),
    currency_code: Yup.string().default("INR"),
    currency_symbol: Yup.string().nullable(),

    exchange_rate: Yup.string().when(["currency_applicable", "currency_code"], {
      is: (applicable: boolean, code: string) => applicable && code !== "INR" && code !== "IND",
      then: (schema) => schema.required("Exchange rate is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    composition_gst: Yup.boolean(),

    select_composition_gst: Yup.string().when("composition_gst", {
      is: (val: boolean) => val === true,
      then: (schema) =>
        schema.required("Composition GST selection is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // Payment Terms
    payment_terms: Yup.string().nullable(),
    payment_terms_amount: Yup.number().typeError("Must be a number").nullable().transform((v) => (v === "" || v === null || v === undefined ? null : v)),
    advance_payment: Yup.number().typeError("Must be a number").nullable(),
    pending_payment: Yup.number().typeError("Must be a number").nullable(),
    next_credit_schedule: Yup.string().nullable(),
    payment_reminder: Yup.number().typeError("Must be a number").nullable(),

    // Inspection & Installation Date
    inspection_applicable: Yup.boolean().default(false),
    inspection: Yup.string().when("inspection_applicable", {
      is: true,
      then: (schema) => schema.required("Inspection is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    inspection_date: Yup.string().when(["inspection_applicable", "inspection"], {
      is: (applicable: boolean, val: string) => applicable && val === "Applicable",
      then: (schema) => schema.required("Inspection Date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    installation: Yup.string().when("inspection_applicable", {
      is: true,
      then: (schema) => schema.required("Installation is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    installation_date: Yup.string().when(["inspection_applicable", "installation"], {
      is: (applicable: boolean, val: string) => applicable && val === "Applicable",
      then: (schema) => schema.required("Installation Date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    technicians: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string().required(),
          fullname: Yup.string().required(),
          username: Yup.string().required(),
        })
      )
      .nullable(),
    // Retention Details (optional)
    retention_details: Yup.object().shape({
      retentionType: Yup.string().nullable(),
      percentage: Yup.number()
        .min(0, "Percentage cannot be negative")
        .max(100, "Percentage cannot be more than 100")
        .nullable(),
      retentionAmount: Yup.number().min(0, "Amount cannot be negative").nullable(),
      followUpDate: Yup.string().nullable(),
    }),

    next_follow_up_date: Yup.string().required("Next follow up date is required"),
    follow_up_remarks: Yup.string().nullable(),

    // EMD Details - emd_applicable toggle controls visibility, mode_of_emd and emd_amount required when applicable
    emd_applicable: Yup.boolean().default(false),
    mode_of_emd: Yup.string().when("emd_applicable", {
      is: true,
      then: (schema) => schema.required("Mode of EMD is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    emd_amount: Yup.number()
      .typeError("EMD Amount must be a number")
      .min(0, "EMD Amount cannot be negative")
      .when("emd_applicable", {
        is: true,
        then: (schema) => schema.required("EMD Amount is required"),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  // FORMIK
  const formik = useFormik<SalesOrderDataRetrive>({
    initialValues: transformedData,
    validationSchema: validationSchema,
    enableReinitialize: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if(items && items.length >= 1){
          await handleSubmitAction(values, "save"); // Always "save" for submit
          // toast.success("Sales order saved successfully");
          navigate(getBackPath());
   
        }
        toast.error("At least one product is required");
        return;
      } catch (err) {
        // Error is already handled in handleSubmitAction
        // Don't navigate on error
      } finally {
        setSubmitting(false);
      }
    },
  });

  useScrollToFormikError(formik.errors, formik.submitCount + validationAttemptCount);

  // Clear company_name error when form has company data (e.g. loaded from backend in edit mode)
  useEffect(() => {
    if (formik.values.company_name?.trim()) {
      setTimeout(() => formik.setFieldError("company_name", undefined), 0);
    }
  }, [formik.values.company_name]);

  const totals = useQuotationCalculations(
    Array.isArray(items) ? items : [],
    "sales_order",
    formik?.values?.bill_from_address,
    shippingAddresses,
    formik
  );

  // Sync selectedMemberIds with formik.values.members
  useEffect(() => {
    const memberIds = (formik.values.members || []).map((m: any) => m.id || m.user_id).filter(Boolean);
    setSelectedMemberIds(memberIds);
  }, [formik.values.members]);

  // Handler for adding a member
  const handleMemberAdd = (user: any) => {
    const userId = user.user_id || user.id;
    if (!selectedMemberIds.includes(userId)) {
      setSelectedMemberIds([...selectedMemberIds, userId]);
      const newMember = {
        id: userId,
        name: `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.username || user.email || "",
        initials: getInitials(user.first_name || "", user.last_name || ""),
      };
      formik.setFieldValue("members", [...(formik.values.members || []), newMember]);
    }
  };

  // Handler for removing a member
  const handleMemberRemove = (memberId: string) => {
    setSelectedMemberIds(selectedMemberIds.filter((id) => id !== memberId));
    formik.setFieldValue(
      "members",
      (formik.values.members || []).filter((m: any) => (m.id || m.user_id) !== memberId)
    );
  };

  // Reactively update shipping addresses when companies data changes (e.g. after adding a new address)
  useEffect(() => {
    if (formik.values.company && companies.length > 0) {
      const currentCompanyId = formik.values.company.company_id || formik.values.company.id;
      const updatedCompany = companies.find((c) => c.id === currentCompanyId);

      if (updatedCompany && updatedCompany.shipping_addresses) {
        const formattedAddresses = updatedCompany.shipping_addresses.map(
          (addr: any) => ({
            id: addr.id,
            address:
              addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
            state: addr.state,
            city: addr.city,
            pin_code: addr.pin_code,
            phone_number: addr.phone_number,
          })
        );

        if (JSON.stringify(formattedAddresses) !== JSON.stringify(shippingAddresses)) {
          setShippingAddresses(formattedAddresses);
          // formik.setFieldValue("company", updatedCompany, false);
        }
      }
    }
  }, [companies, formik.values.company?.id, formik.values.company?.company_id]);

  // useEffect(() => {
  //   console.log("Formik Values:", formik.values);
  //   console.log("Formik Errors:", formik.errors);
  //   console.log("Formik Touched:", formik.touched);
  // }, [formik.values, formik.errors, formik.touched]);

  // Handler for adding items from ProductAndServiceSection
  const handleProductAdd = (item: any) => {
    // console.log("item in handleProductAdd: ", item);

    // Check for duplicate items
    setItems((prevItems) => {
      // Check if item with same item ID already exists
      const isDuplicateById = prevItems.some(
        (existingItem) => existingItem.item && existingItem.item === item.item
      );

      // Check if item with same item_name already exists (for products/services)
      const itemName = item.productName;
      const isDuplicateByName = prevItems.some((existingItem) => {
        const existingItemName =
          true
            ? existingItem.productName
            : existingItem.serviceName;
        return (
          existingItemName &&
          existingItemName.toLowerCase() === itemName?.toLowerCase()
        );
      });

      if (isDuplicateById || isDuplicateByName) {
        toast.error(
          "This item is already added. Please select a different item."
        );
        return prevItems; // Don't add the duplicate item
      }

      // If no duplicate, add the item
      return [...prevItems, item];
    });
  };

  // mapped item details
  const mapQuotationItemToFormItem = (item: any) => {
    // Convert numeric strings to actual numbers for easier calculation in the UI
    const toNum = (value: any) => (value ? Number(value) : 0);

    return {
      // Core Identifiers and Names
      id: item.id,
      item_name: item.item_name || item.product_name || "",
      item_type: item.item_type || "products", // Use item_type from your quote data
      category_name: item.category_name,
      sub_category_name: item.sub_category_name,
      make_name: item.make_name,
      model_name: item.model_name,

      // Financials (Converted to Number for better UI interaction)
      quantity: toNum(item.quantity),
      unit_price: toNum(item.unit_price),

      // Note: Your QUOTATION data uses 'discount', but the interface uses 'discount_percent' and 'discount_amount'.
      // Set discount_percent only when discount_type is "%"
      discount_percent: item.discount_type === "%"
        ? (toNum(item.discount_percent || item.discount || 0))
        : null,
      discount_amount: toNum(item.discount_value || 0),

      net_value: toNum(item.net_value),

      // GST/Tax Details
      gst_percent: toNum(item.gst_percent || 0),
      original_gst_percent: toNum(item.gst_percent || 0),
      warranty_in_months: item.warrenty_in_months || item.warranty_in_months || "",
      warranty_date: item.warrenty_date || item.warranty_date || "",
      cgst_percent: toNum(item.cgst_percent || 0), // Use default if API only provides 'gst_percent'
      igst_percent: toNum(item.igst_percent || 0),
      sgst_percent: toNum(item.sgst_percent || 0),
      gst_amount: toNum(item.gst_value || 0), // Assuming 'gst_value' is the amount

      total_amount: toNum(item.total_price), // Assuming 'total_price' is the grand total for the item

      // Serviceability & Dates (Check for nulls and provide defaults)
      is_serviceable: item.is_serviceable || false,
      installation: item.installation || null,
      installation_date: item.installation_date || null,
      inspection: item.inspection || null,
      inspection_date: item.inspection_date || null,

      // Foreign Keys (UUIDs) - Keep as strings
      item: item.item,
      category: item.category,
      sub_category: item.sub_category,
      make: item.make,
      model: item.model,

      // Shipping Address - map shipping_id to shipping_address_id
      // Check both shipping_id and shipping_address.id, and also check if shipping_address is an object with an id
      shipping_address_id: (() => {
        // Priority: shipping_address_id > shipping_id > shipping_address.id
        if (item.shipping_address_id) {
          return item.shipping_address_id;
        }
        if (item.shipping_id) {
          return item.shipping_id;
        }
        if (
          item.shipping_address &&
          typeof item.shipping_address === "object" &&
          item.shipping_address.id
        ) {
          return item.shipping_address.id;
        }
        return null;
      })(),

      // Additional fields not in your interface but might be useful
      product_quotation: item.product_quotation || null,
      service_quotation: item.service_quotation || null,
    };
  };


  //   data: any,
  //   isSalesOrder = false,
  //   trueMode = false
  // ) => {
  //   const details = data;
  //   // console.log("mapping details in sales order: ", details, isSalesOrder);
  //   // console.log("bill_from_address from API:", details?.bill_from_address);
  //   // console.log("bill_from from API:", details?.bill_from);
  //   // console.log("organizationsState:", organizationsState);

  //   // SCENARIO: Get the company ID from the API data.
  //   // The API returns the company ID directly in 'details.company'
  //   const companyIdFromApi = details.company;

  //   // FIX 1: Find the full company object from the props array using the ID.
  //   // This full object is necessary for the Autocomplete component.
  //   const companyObj = companies.find((c) => c.id === companyIdFromApi) || null;
  //   // console.log("companyObj : ", companyObj);

  //   // Extract shipping addresses from the company object
  //   if (companyObj?.shipping_addresses) {
  //     const formattedAddresses = companyObj.shipping_addresses.map(
  //       (addr: any) => ({
  //         id: addr.id,
  //         address:
  //           addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
  //         state: addr.state,
  //         city: addr.city,
  //         pin_code: addr.pin_code,
  //       })
  //     );
  //     setShippingAddresses(formattedAddresses);
  //     // console.log("Set shippingAddresses from company:", formattedAddresses);
  //   }

  //   // Also check if items have shipping_address objects that need to be added
  //   const itemShippingAddresses: any[] = [];
  //   (details?.item_details || []).forEach((item: any) => {
  //     if (
  //       item.shipping_address &&
  //       typeof item.shipping_address === "object" &&
  //       Object.keys(item.shipping_address).length > 0
  //     ) {
  //       const shippingAddr = item.shipping_address as any;
  //       if (
  //         shippingAddr.id &&
  //         !itemShippingAddresses.find((addr) => addr.id === shippingAddr.id)
  //       ) {
  //         itemShippingAddresses.push({
  //           id: shippingAddr.id,
  //           address:
  //             shippingAddr.address ||
  //             `${shippingAddr.city}, ${shippingAddr.state}, ${shippingAddr.pin_code}`,
  //           state: shippingAddr.state,
  //           city: shippingAddr.city,
  //           pin_code: shippingAddr.pin_code,
  //         });
  //       }
  //     }
  //   });

  //   // Add item shipping addresses to the state if they don't already exist
  //   if (itemShippingAddresses.length > 0) {
  //     setShippingAddresses((prev) => {
  //       const newAddresses = [...prev];
  //       itemShippingAddresses.forEach((addr) => {
  //         if (!newAddresses.find((a) => a.id === addr.id)) {
  //           newAddresses.push(addr);
  //         }
  //       });
  //       // console.log("Added item shipping addresses:", itemShippingAddresses);
  //       // console.log("Final shippingAddresses:", newAddresses);
  //       return newAddresses;
  //     });
  //   }

  //   // FIX 2: Find the contact person object within the full company object.
  //   // We match by the contact_person_name returned at the top level of the API response.
  //   // const organizationObj = organizationsState.find(org => org.id === details.organization);
  //   const contact =
  //     (companyObj?.contact_details || []).find(
  //       (c: any) => c.contact_person_name === details.contact_person_name
  //     ) || null;

  //   // FIX 3: Map the API's agent object structure to the expected Agent interface.
  //   // The API uses agent_name, agent_designation, etc.
  //   const agentData = details.agent
  //     ? {
  //       agent_name: details?.agent.agent_name || "N/A",
  //       agent_designation: details?.agent.agent_designation || "",
  //       agent_department: details?.agent.agent_department || "",
  //     }
  //     : null;

  //   // quotation obj filter - find and set the quotation object
  //   // Use details?.id when creating from quotation, details?.quotation when editing sales order
  //   const quotationId = details?.quotation || details?.id;
  //   if (quotationId) {
  //     // If user is actively selecting, don't override their selection
  //     if (
  //       isUserSelectingQuotation.current &&
  //       selectedQuotation &&
  //       selectedQuotation.id === quotationId
  //     ) {
  //       // User selection matches loaded data, preserve it and reset flag
  //       isUserSelectingQuotation.current = false;
  //     } else if (
  //       !isUserSelectingQuotation.current &&
  //       quotationRefenrence &&
  //       Array.isArray(quotationRefenrence)
  //     ) {
  //       // Not a user selection, find and set from loaded data
  //       const quotationOBJ = quotationRefenrence.find(
  //         (q: any) => q.id === quotationId
  //       );
  //       // console.log(
  //       //   "quotationOBJ : ",
  //       //   quotationOBJ,
  //       //   "quotationId:",
  //       //   quotationId,
  //       //   "quotationRefenrence:",
  //       //   quotationRefenrence
  //       // );
  //       if (quotationOBJ) {
  //         setSelectedQuotation(quotationOBJ);
  //       }
  //     }
  //   }
  //   // FIX 4: Map Assigned Members
  //   const assignedMembersFromApi = details.assigned_member_details || [];
  //   // If the API returns full member objects, use them directly.
  //   // If it returns simple {id: '...', name: '...'} and your 'membersOptions' are fuller, you'd need to map those.
  //   // Based on the console log, the objects look rich enough to be used directly if they match the option structure.
  //   const mappedMembers = assignedMembersFromApi.map(
  //     (member: any) =>
  //       // We ensure the object structure matches what 'membersOptions' provides,
  //       // specifically for the Autocomplete to find the full object to display the name.
  //       // Assuming membersOptions are full user/member objects.
  //       technicianOptions.find(
  //         (m: any) => m.id === member.id || m.id === member.user
  //       ) || member
  //   );

  //   // console.log("mappedMembers : ", mappedMembers);
  //   const itemDetails = details?.item_details || [];
  //   // console.log("trueMode : ", trueMode);
  //   formik.setValues((prev: any) => ({
  //     ...prev,

  //     // QUOTATION-SPECIFIC FIELDS (Autofill only on Edit, or leave blank/user-input)
  //     quotation_number: details?.quotation_number || "",
  //     quotation: true ? details?.quotation : details?.id,
  //     enquiry: details?.enquiry || "",
  //     valid_until_date: details?.valid_until_date || "",
  //     billing_address: details?.billing_address,
  //     shipping_address: details?.shipping_address,
  //     sales_order: true ? details?.id : "",
  //     sales_order_date: details?.sales_order_date || "",
  //     valid_until: details?.valid_until || "",
  //     initiated_by: details?.initiated_by || "", // Use initiated_by from your API
  //     terms_and_conditions: details?.terms_and_conditions || [],
  //     notes: details?.notes || "",
  //     subtotal_before_discount: details?.subtotal_before_discount || "",
  //     total_item_discounts: details?.total_item_discounts || "",
  //     net_total: details?.net_total || "",
  //     total_gst_value: details?.total_gst_value || "",
  //     grand_total_amount: details?.grand_total_amount || "",
  //     // Use the enquiry_number from API when creating from enquiry
  //     enquiry_number:
  //       details?.enquiry_reference || details?.enquiry_number || "",

  //     // ENQUIRY DATA FIELDS (Autofill in all scenarios)
  //     source_of_quotation:
  //       details?.sourceOfEnquiry || details?.source_of_enquiry || null,

  //     // Map Company and Contact (using the objects found/created above)
  //     company: companyObj, // FIX: Full Company object
  //     company_name: companyObj?.company_name,
  //     industry: details.industry || companyObj?.industry || "",

  //     // PBG Section
  //     pbg_details: details?.pbg_details || initialPBGDetail,

  //     // Currency & Composition Section
  //     currency_code: details?.currency_code || "INR", // Default currency,
  //     currency_symbol: details?.currency_symbol || "₹", // Default currency symbol
  //     exchange_rate: details?.exchange_rate || "1",
  //     composition_gst: details?.composition_gst || false,
  //     select_composition_gst: details?.select_composition_gst || "",

  //     // Payment Terms
  //     payment_terms: details?.payment_terms || "",
  //     advance_payment: details?.advance_payment || "",
  //     pending_payment: details?.pending_payment || "",
  //     next_credit_schedule: details?.next_credit_schedule || null,
  //     payment_reminder: details?.payment_reminder || "",

  //     // Inspection & Installation section
  //     inspection: details?.inspection || "", // e.g., "Applicable" or "Not Applicable"
  //     inspection_date: details?.inspection_date || "", // required only if inspection === "Applicable"
  //     installation: details?.installation || "", // e.g., "Applicable" or "Not Applicable"
  //     installation_date: details?.installation_date || "", // required only if installation === "Applicable"

  //     // Bill Section
  //     bill_to: details?.bill_to || "",
  //     bill_from: details?.bill_from || "",
  //     bill_to_address: details?.billing_address || null,
  //     // Handle bill_from_address: if empty object, try to find from organizationsState, otherwise use the value or null
  //     bill_from_address: (() => {
  //       const billFromAddr = details?.bill_from_address;
  //       // console.log(
  //       //   "Processing bill_from_address:",
  //       //   billFromAddr,
  //       //   "Type:",
  //       //   typeof billFromAddr
  //       // );

  //       // Check if it's an empty object (no keys or all values are falsy)
  //       const isEmptyObject =
  //         billFromAddr &&
  //         typeof billFromAddr === "object" &&
  //         !Array.isArray(billFromAddr) &&
  //         Object.keys(billFromAddr).length === 0;

  //       // console.log("Is empty object?", isEmptyObject);

  //       if (isEmptyObject) {
  //         // console.log("bill_from ID:", details?.bill_from);
  //         // If bill_from ID exists, try to find the organization from organizationsState
  //         if (
  //           details?.bill_from &&
  //           organizationsState &&
  //           organizationsState.length > 0
  //         ) {
  //           const orgObj = organizationsState.find(
  //             (org: any) => org.id === details.bill_from
  //           );
  //           // console.log("Found organization:", orgObj);
  //           if (orgObj && orgObj.org_address) {
  //             // console.log("Returning org_address:", orgObj.org_address);
  //             return orgObj.org_address; // Return the address string
  //           }
  //         }
  //         // Return empty string if empty object and no organization found (for freeSolo Autocomplete)
  //         // console.log("Returning empty string for bill_from_address");
  //         return "";
  //       }

  //       // If it's a string, use it directly
  //       if (typeof billFromAddr === "string") {
  //         // console.log("bill_from_address is string:", billFromAddr);
  //         return billFromAddr;
  //       }

  //       // If it's an object with properties, check if it has org_address or construct from address fields
  //       if (
  //         billFromAddr &&
  //         typeof billFromAddr === "object" &&
  //         !Array.isArray(billFromAddr) &&
  //         Object.keys(billFromAddr).length > 0
  //       ) {
  //         // console.log(
  //         //   "bill_from_address is object with properties:",
  //         //   billFromAddr
  //         // );
  //         // If it has org_address, use it
  //         if (billFromAddr.org_address) {
  //           return billFromAddr.org_address;
  //         }
  //         // Otherwise, construct address string from individual fields
  //         if (billFromAddr.address || billFromAddr.city || billFromAddr.state) {
  //           const parts = [
  //             billFromAddr.address,
  //             billFromAddr.city,
  //             billFromAddr.state,
  //             billFromAddr.pin_code,
  //           ].filter(Boolean);
  //           const constructed = parts.length > 0 ? parts.join(", ") : "";
  //           // console.log("Constructed address:", constructed);
  //           return constructed;
  //         }
  //         // If object has properties but no address fields, return empty string
  //         return "";
  //       }

  //       // Default to empty string for freeSolo Autocomplete
  //       // console.log("Returning default empty string");
  //       return "";
  //     })(),
  //     // Autofill individual contact fields directly from the API response
  //     contactPerson: contact, // FIX: Full Contact object for Autocomplete
  //     contactPersonArray: details?.contactPersonArray || [],
  //     contact_person_name:
  //       details.contact_person_name || contact?.contact_person_name || "",
  //     contact_person_designation:
  //       details.contact_person_designation ||
  //       contact?.contact_person_designation ||
  //       "",
  //     contact_person_phone_no:
  //       details.contact_person_phone_no ||
  //       contact?.contact_person_phone_no ||
  //       "",
  //     contact_person_email:
  //       details.contact_person_email || contact?.contact_person_email || "",

  //     // Map Agent (using the object created above)
  //     agent: agentData, // FIX: Mapped Agent object for Autocomplete
  //     designation: agentData?.agent_designation || "",
  //     department: agentData?.agent_department || "",
  //     emd: details.emd || "",
  //     agent_name: agentData?.agent_name || "",
  //     // Map Assigned Members
  //     members: mappedMembers, // FIX: Mapped Array of Member objects
  //   }));

  //   // Map Item Details
  //   // Get current shipping addresses from companyObj (not state, as state updates are async)
  //   const currentShippingAddresses = companyObj?.shipping_addresses || [];

  //   // Collect all shipping addresses from items that need to be added
  //   const itemShippingAddressesToAdd: any[] = [];

  //   const mappedItemDetails = (details?.item_details || []).map((item: any) => {
  //     const mappedItem = mapQuotationItemToFormItem(item);

  //     // console.log(
  //     //   "Mapping item:",
  //     //   item.id,
  //     //   "shipping_address_id:",
  //     //   mappedItem.shipping_address_id,
  //     //   "shipping_address:",
  //     //   item.shipping_address,
  //     //   "shipping_id:",
  //     //   item.shipping_id
  //     // );

  //     // If shipping_address_id exists, check if it's in company addresses
  //     if (mappedItem.shipping_address_id) {
  //       const addrExists = currentShippingAddresses.find(
  //         (addr: any) => addr.id === mappedItem.shipping_address_id
  //       );
  //       // console.log(
  //       //   "Address exists in company addresses?",
  //       //   !!addrExists,
  //       //   "for ID:",
  //       //   mappedItem.shipping_address_id
  //       // );

  //       // If not found in company addresses, check if item has shipping_address object with data
  //       if (
  //         !addrExists &&
  //         item.shipping_address &&
  //         typeof item.shipping_address === "object"
  //       ) {
  //         const shippingAddr = item.shipping_address as any;
  //         // Check if it's not an empty object
  //         if (Object.keys(shippingAddr).length > 0) {
  //           // If it has an ID, use it; otherwise try to match by address content
  //           if (shippingAddr.id) {
  //             // Add to list to be added to state
  //             if (
  //               !itemShippingAddressesToAdd.find(
  //                 (addr) => addr.id === shippingAddr.id
  //               )
  //             ) {
  //               itemShippingAddressesToAdd.push({
  //                 id: shippingAddr.id,
  //                 address:
  //                   shippingAddr.address ||
  //                   `${shippingAddr.city}, ${shippingAddr.state}, ${shippingAddr.pin_code}`,
  //                 state: shippingAddr.state,
  //                 city: shippingAddr.city,
  //                 pin_code: shippingAddr.pin_code,
  //               });
  //             }
  //           } else if (shippingAddr.address || shippingAddr.city) {
  //             // If no ID but has address data, try to find matching address in company addresses by content
  //             const matchingAddr = currentShippingAddresses.find(
  //               (addr: any) =>
  //                 addr.address === shippingAddr.address ||
  //                 (addr.city === shippingAddr.city &&
  //                   addr.state === shippingAddr.state &&
  //                   addr.pin_code === shippingAddr.pin_code)
  //             );
  //             if (matchingAddr) {
  //               // Update the mapped item with the matching address ID
  //               mappedItem.shipping_address_id = matchingAddr.id;
  //               // console.log(
  //               //   "Matched shipping address by content, using ID:",
  //               //   matchingAddr.id
  //               // );
  //             }
  //           }
  //         }
  //       }
  //     } else {
  //       // If no shipping_address_id, try to find it from shipping_address object
  //       if (
  //         item.shipping_address &&
  //         typeof item.shipping_address === "object" &&
  //         Object.keys(item.shipping_address).length > 0
  //       ) {
  //         const shippingAddr = item.shipping_address as any;
  //         if (shippingAddr.id) {
  //           mappedItem.shipping_address_id = shippingAddr.id;
  //           // console.log(
  //           //   "Set shipping_address_id from shipping_address.id:",
  //           //   shippingAddr.id
  //           // );

  //           // Add to list if not in company addresses
  //           const addrExists = currentShippingAddresses.find(
  //             (addr: any) => addr.id === shippingAddr.id
  //           );
  //           if (
  //             !addrExists &&
  //             !itemShippingAddressesToAdd.find(
  //               (addr) => addr.id === shippingAddr.id
  //             )
  //           ) {
  //             itemShippingAddressesToAdd.push({
  //               id: shippingAddr.id,
  //               address:
  //                 shippingAddr.address ||
  //                 `${shippingAddr.city}, ${shippingAddr.state}, ${shippingAddr.pin_code}`,
  //               state: shippingAddr.state,
  //               city: shippingAddr.city,
  //               pin_code: shippingAddr.pin_code,
  //             });
  //           }
  //         }
  //       }
  //     }

  //     return mappedItem;
  //   });

  //   // Add item shipping addresses to state if any were found
  //   if (itemShippingAddressesToAdd.length > 0) {
  //     setShippingAddresses((prev) => {
  //       const newAddresses = [...prev];
  //       itemShippingAddressesToAdd.forEach((addr) => {
  //         if (!newAddresses.find((a) => a.id === addr.id)) {
  //           newAddresses.push(addr);
  //         }
  //       });
  //       // console.log(
  //       //   "Added item shipping addresses to state:",
  //       //   itemShippingAddressesToAdd
  //       // );
  //       return newAddresses;
  //     });
  //   }

  //   // console.log("itemDetails in quotation form: ", itemDetails);
  //   // console.log(
  //   //   "mappedItemDetails with shipping_address_id: ",
  //   //   mappedItemDetails
  //   // );
  //   // console.log("currentShippingAddresses: ", currentShippingAddresses);
  //   // console.log(
  //   //   "Final shippingAddresses state will include:",
  //   //   itemShippingAddressesToAdd
  //   // );
  //   console.log("mappedItemDetails in ProductSalesOrderEditForm =>", mappedItemDetails);
  //   setItems(mappedItemDetails);

  //   // Update the selected enquiry reference for SCENARIO 1 UI
  //   // if (!isQuotation) {
  //   // You might need to find the full reference object based on 'details.id'
  //   //   setSelectedEnquiry(
  //   //     enquiryReferences.find((r) => r.id === details.id) || null
  //   //   );
  //   // }
  // };

  // ---- Fetch and Load Logic (Main useEffect) ----
  const dataLoadedRef = useRef<string | null>(null);
  useEffect(() => {
    if (!id) return;

    // Reset ref and error if id changes
    if (dataLoadedRef.current !== id) {
      dataLoadedRef.current = null;
      setLoadingError(null);
    }

    if (dataLoadedRef.current === id) return; // Prevent multiple loads for same id

    const loadData = async () => {
      dataLoadedRef.current = id;
      setLoading(true);
      setLoadingError(null); // Reset error state

      try {

        const response = await dispatch(fetchProductSalesOrderById(id as string)).unwrap();
        // console.log("response in line 1226", response);
        // Handle response structure: response.data.data or response.data
        const salesOrderData = response?.data?.data || response?.data || response;
        // console.log("Sales order data to transform:", salesOrderData);

        if (salesOrderData) {
          // Transform the data immediately
          const transformed = transformBackendDataToFormData(salesOrderData);

          // console.log("Transformed data for ProductSalesOrderEditForm:", transformed);
          // console.log("Currency code in transformed:", transformed.currency_code);
          // console.log("Order date in transformed:", transformed.sales_order_date);
          // console.log("ETA date in transformed:", transformed.valid_until_date);
          // console.log("Contact person array in transformed:", transformed.contactPersonArray);

          setInitialData(salesOrderData);
          
          const existingAttachments = salesOrderData?.attachments || [];
          const existingPbgDocs = salesOrderData?.pbg_documents || [];
          const existingPoDocs = salesOrderData?.customer_details?.customer_po_documents || [];
          
          setExistingDocuments(existingAttachments);
          setExistingPbgDocuments(existingPbgDocs);
          setExistingPoDocuments(existingPoDocs);
          
          // Merge existing URLs into formik values so payload builder can include them
          transformed.attachments = [];
          transformed.pbg_details.upload_document = [];
          transformed.customer_po_document_url = [];
          
          setTransformedData(transformed);

          // Reset formik with new values immediately - this will update all form fields
          formik.resetForm({
            values: transformed,
          });

          // After resetting formik, ensure currency symbol is set if currency list is already loaded
          if (transformed.currency_code && currencyList && currencyList.length > 0) {
            const selectedCurrency = currencyList.find(
              (c) => c.value === transformed.currency_code
            );
            if (selectedCurrency && selectedCurrency.currency_symbol && transformed.currency_symbol !== selectedCurrency.currency_symbol) {
              formik.setFieldValue("currency_symbol", selectedCurrency.currency_symbol);
            }
          }

          // Set items from sales_order_products for ProductAndServiceSection
          if (transformed.item_details && Array.isArray(transformed.item_details) && transformed.item_details.length > 0) {
            // console.log("Setting items from transformed.item_details:", transformed.item_details);
            setItems(transformed.item_details);
          } else {
            // console.log("No item_details found or empty array");
            setItems([]);
          }

          // Set shipping addresses from customer_details
          if (transformed.shipping_address && Array.isArray(transformed.shipping_address) && transformed.shipping_address.length > 0) {
            const mappedShippingAddresses = transformed.shipping_address.map((addr: any) => ({
              id: addr.shipping_address_id || addr.id || "",
              address: addr.address || "",
              city: addr.city || "",
              state: addr.state || "",
              country: addr.country || "",
              pin_code: addr.pin_code || addr.pincode || "",
              phone_number: addr.phone_number || "",
            }));
            // console.log("Setting shipping addresses:", mappedShippingAddresses);
            setShippingAddresses(mappedShippingAddresses);
          } else {
            setShippingAddresses([]);
          }

          // Only set loading to false if we successfully loaded data
          setLoading(false);
        } else {
          // No data received, show error
          // console.warn("No sales order data received");
          setLoadingError("Failed to fetch sales order data. No data received.");
          setLoading(false);
        }

      } catch (error: any) {
        // console.error("Failed to load data:", error);
        const errorMessage = error?.message || error?.error || "Failed to fetch sales order data. Please try again.";
        setLoadingError(errorMessage);
        toast.error("Failed to load data for the form.");
        dataLoadedRef.current = null; // Reset on error to allow retry
        setLoading(false); // Stop loading and show error
      }
    };

    loadData();
  }, [id, dispatch]);

  // Update company object with all contact_details from companies array
  useEffect(() => {
    // Early return if required data is not available
    if (!formik.values.company || !companies || companies.length === 0) {
      return;
    }

    const currentCompanyId = formik.values.company?.company_id || formik.values.company?.id;
    if (!currentCompanyId) {
      return;
    }

    // Find the full company object from companies array
    const fullCompany = companies.find(
      (c: any) => c.id === currentCompanyId || c.company_id === currentCompanyId
    );

    // If full company found and it has contact_details or contacts, update the company object in formik
    const companyContacts = fullCompany?.contact_details || fullCompany?.contacts || [];
    if (fullCompany && Array.isArray(companyContacts) && companyContacts.length > 0) {
      // Transform contact_details/contacts to match form format
      const transformedContacts = companyContacts.map((contact: any) => ({
        id: contact.contact_id || contact.id || "",
        contact_id: contact.contact_id || contact.id || "",
        contact_person_name: contact.name || contact.contact_person_name || "",
        contact_person_email: contact.email || contact.contact_person_email || "",
        contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
        contact_person_designation: contact.designation || contact.contact_person_designation || "",
        contact_person_department: contact.contact_person_department || contact.department || "",
      }));

      // Update company object with all contact_details, preserving other company properties
      formik.setFieldValue("company", {
        ...formik.values.company,
        contact_details: transformedContacts,
      }, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies, formik.values.company?.company_id, formik.values.company?.id]);

  // Map assigned members to match membersOptions structure when both are available
  useEffect(() => {
    // Early return if required data is not available
    if (!transformedData || !membersOptions || !Array.isArray(membersOptions) || membersOptions.length === 0) {
      return;
    }

    if (transformedData.members && Array.isArray(transformedData.members) && transformedData.members.length > 0) {
      const mappedMembers = transformedData.members.map((member: any) => {
        // Find matching member in membersOptions by user_id or id
        const matchedMember = membersOptions.find(
          (m: any) =>
            (m.user_id && member.user_id && m.user_id === member.user_id) ||
            (m.id && member.id && m.id === member.id) ||
            (m.user_id && member.id && m.user_id === member.id) ||
            (m.id && member.user_id && m.id === member.user_id)
        );

        // If found, use the full member object from membersOptions; otherwise use the transformed member
        return matchedMember || member;
      });

      // Only update if the mapped members are different from current formik values
      const currentMembers = formik.values.members || [];
      const membersChanged = mappedMembers.length !== currentMembers.length ||
        mappedMembers.some((m: any, idx: number) => {
          const current = currentMembers[idx];
          return !current || (m.user_id || m.id) !== (current.user_id || current.id);
        });

      if (membersChanged) {
        formik.setFieldValue("members", mappedMembers);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transformedData, membersOptions]);

  // Sync currency symbol and code when currencyList loads after data is already set
  // This handles the case where currencyList loads after the initial data transformation
  const currencySyncedRef = useRef(false);
  const currencyCodeRef = useRef<string>("");
  useEffect(() => {
    if (
      currencyList &&
      currencyList.length > 0 &&
      initialData &&
      !currencySyncedRef.current
    ) {
      const currentCurrencyCode = formik.values.currency_code;
      const currentCurrencySymbol = formik.values.currency_symbol;

      // If we have a currency_code, sync the symbol
      if (currentCurrencyCode) {
        const selectedCurrency = currencyList.find(
          (c) => c.value === currentCurrencyCode
        );
        if (selectedCurrency && selectedCurrency.currency_symbol && currentCurrencySymbol !== selectedCurrency.currency_symbol) {
          // console.log("Updating currency symbol to:", selectedCurrency.currency_symbol);
          formik.setFieldValue("currency_symbol", selectedCurrency.currency_symbol);
        }
      }

      // If we have a foreign currency_symbol but currency_code is INR, find the correct code
      if (currentCurrencySymbol && currentCurrencySymbol !== "₹" && (currentCurrencyCode === "INR" || currentCurrencyCode === "IND" || !currentCurrencyCode)) {
        const matchingCurrency = currencyList.find(
          (c) => c.currency_symbol === currentCurrencySymbol
        );
        if (matchingCurrency && matchingCurrency.value) {
          // console.log("Updating currency code to:", matchingCurrency.value, "for symbol:", currentCurrencySymbol);
          formik.setFieldValue("currency_code", matchingCurrency.value);
          currencyCodeRef.current = matchingCurrency.value;
        }
      }

      currencySyncedRef.current = true;
      if (currentCurrencyCode) {
        currencyCodeRef.current = currentCurrencyCode;
      }
    }
  }, [currencyList?.length, initialData?.sales_order_id]);


  // Debug logging for items
  useEffect(() => {
    // console.log("Items state changed:", items);
  }, [items]);

  // Sync calculated totals to formik values so they're included in the payload
  // Use ref to track previous totals to prevent unnecessary updates
  const prevTotalsRef = useRef<any>(null);
  useEffect(() => {
    if (totals && formik) {
      // Only update if totals have actually changed
      const totalsChanged =
        !prevTotalsRef.current ||
        prevTotalsRef.current.subTotal !== totals.subTotal ||
        prevTotalsRef.current.discount !== totals.discount ||
        prevTotalsRef.current.gst !== totals.gst ||
        prevTotalsRef.current.netTotal !== totals.netTotal ||
        prevTotalsRef.current.grandTotal !== totals.grandTotal;

      if (totalsChanged) {
        // Batch all updates together to minimize re-renders
        // Use setFieldValue with validate: false to prevent validation loops
        formik.setFieldValue("subtotal_before_discount", totals.subTotal.toString(), false);
        formik.setFieldValue("total_item_discounts", totals.discount.toString(), false);
        formik.setFieldValue("total_gst", totals.gst.toString(), false);
        formik.setFieldValue("net_taxable_value", totals.netTotal.toString(), false);
        formik.setFieldValue("total_amount", totals.grandTotal.toString(), false);
        formik.setFieldValue("total_gst_value", totals.gst.toString(), false);
        prevTotalsRef.current = { ...totals };
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totals?.subTotal, totals?.discount, totals?.gst, totals?.netTotal, totals?.grandTotal]);

  // const handleSubmit = async (e: any, action: "draft" | "print" | "save") => {
  //   e.preventDefault();

  //   if (formData.members.length === 0) {
  //     toast("Please select at least one member");
  //     return;
  //   }
  //   console.log("formData and items on submit: ", formData, items);
  //   console.log("type", type);
  //   const payload = buildSalesOrderPayload(
  //     formData,
  //     items,
  //     type,
  //     shippingAddresses,
  //     organizationsState
  //   );

  //   console.log("✅ Final Sales Order Payload:", payload);

  //   try {
  //     setLoading(true);

  //     // await onSave(payload, action);
  //     // Navigation is handled by parent form component
  //   } catch (err: any) {
  //     toast.error(err?.message || "Operation failed.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // console.log("formik values in line 1105", formik.values)
  const handleSubmitAction = async (
    values: SalesOrderDataRetrive,
    action: "draft" | "save"
  ) => {
    // console.log("FORM1 DATA  =>", values);
    // console.log("FORM1 ACTION  => ", action);
    // if (
    //   action !== "draft" &&
    //   (!values.members || values.members.length === 0)
    // ) {
    //   toast.error("Please select at least one member");
    //   throw new Error("Please select at least one member");
    // }

    // Merge existing documents into formik values so they're included in the payload
    // Existing documents are stored in state, but payload builder only uses formik values
    const valuesWithExistingDocs = {
      ...values,
      customer_po_document_url: (() => {
        const newDocs = Array.isArray(values.customer_po_document_url) 
          ? values.customer_po_document_url 
          : values.customer_po_document_url ? [values.customer_po_document_url] : [];
        // Combine new uploads (File objects) with existing documents (URL strings)
        return [...existingPoDocuments, ...newDocs];
      })(),
      pbg_details: {
        ...values.pbg_details,
        upload_document: (() => {
          const newDocs = Array.isArray(values.pbg_details?.upload_document) 
            ? values.pbg_details.upload_document 
            : values.pbg_details?.upload_document ? [values.pbg_details.upload_document] : [];
          // Combine new uploads (File objects) with existing documents (URL strings)
          return [...existingPbgDocuments, ...newDocs];
        })(),
      },
      attachments: (() => {
        const newDocs = Array.isArray(values.attachments) 
          ? values.attachments 
          : values.attachments ? [values.attachments] : [];
        // Combine new uploads (File objects) with existing documents (URL strings)
        return [...existingDocuments, ...newDocs];
      })(),
    };

    const payload = buildSalesOrderPayload(
      valuesWithExistingDocs,
      items,

      action,
      shippingAddresses,
      organizationsState,
      true // isEdit = true for edit form
    );
    // console.log("payload in line 1146", payload)
    try {
      // Set appropriate loading state based on action
      if (action === "draft") {
        setSavingDraft(true);
      } else {
        setSaving(true);
      }
      // console.log("payload in line 1941", payload);
      if(items && items.length == 0){
        toast.error("At least one product is required");
        return;
      }
      await onSave(payload, action);
    } catch (err: any) {
      // Extract error message from various possible error structures
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.response?.data ||
        err?.message ||
        (typeof err === 'string' ? err : "Operation failed.");

      toast.error(errorMessage);
      throw err; // Re-throw error so caller knows it failed
    } finally {
      // Reset appropriate loading state based on action
      if (action === "draft") {
        setSavingDraft(false);
      } else {
        setSaving(false);
      }
    }
  };

  return (
    <>
      <style>
        {`
                  .accordion-terms-conditions .accordion-button,
                  .accordion-notes .accordion-button,
                  .accordion-attach-files .accordion-button {
                    background-color: ${MecordColors?.LightThemeBGColor} !important;
                    color: ${MecordColors?.ActiveText} !important;
                  }
                  .accordion-terms-conditions .accordion-button:not(.collapsed),
                  .accordion-notes .accordion-button:not(.collapsed),
                  .accordion-attach-files .accordion-button:not(.collapsed) {
                    background-color: ${MecordColors?.LightThemeBGColor} !important;
                    color: ${MecordColors?.ActiveText} !important;
                  }
                `}
      </style>

      <PageContainer>
        {/* ---- Header ---- */}
        <FormBreadcrumb
          formName={
            "Sales Order"
          }
          isEdit={true}
          navigatePath={
            getBackPath()
          }
        />
        <hr />

        {/* Show loading spinner while data is being fetched or transformed */}
        {loading && !loadingError && <LoadingSpinner label="Loading Sales Order Data..." />}

        {/* Show error message if data failed to load */}
        {loadingError && (
          <Alert variant="danger" className="my-4">
            <Alert.Heading>Failed to Load Data</Alert.Heading>
            <p>{loadingError}</p>
          </Alert>
        )}

        {/* Show form only when data is loaded */}
        {!loading && !loadingError && initialData && (
          <>
            {/* <div className="d-flex align-items-center mb-4 gap-2">
              <span
                style={{ fontSize: "20px", cursor: "pointer" }}
                onClick={() => navigate(-1)}
              >
                ←
              </span>
              <h5 className="fw-bold mb-0">
                {true ? "Edit Sales Order" : "Create Sales Order"}
              </h5>
            </div> */}

            {/* {true ? (
              <LoadingSpinner/>
            ):( */}

            <Form onSubmit={formik.handleSubmit}>
              <Row className="mb-4 g-4">
                {/* Sales Order Details - LEFT COLUMN */}
                <Col xs={12} md={6}>
                  <div className="rounded mb-3">
                    <div className="d-flex justify-content-start mb-3">
                      <h5 className="fw-semibold mb-2">Sales Order Details</h5>
                    </div>
                    <Row
                      className="g-3 pb-3 px-1 rounded"
                      style={{ backgroundColor: MecordColors?.LightGrayColor }}
                    >
                      {/* Sales Order Date */}
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Sales Order Date{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>

                          <Form.Control
                            type="date"
                            name="sales_order_date"
                            value={formatDateForInput(formik.values.sales_order_date)}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            // readOnly={true}
                            isInvalid={
                              formik.touched.sales_order_date &&
                              !!formik.errors.sales_order_date
                            }
                          />

                          <Form.Control.Feedback type="invalid">
                            {formik.errors.sales_order_date}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* Valid Until Date */}
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Valid Until Date <span className="text-danger">*</span>
                          </Form.Label>

                          <Form.Control
                            type="date"
                            name="valid_until_date"
                            autoComplete="off"
                            value={formatDateForInput(formik.values.valid_until_date)}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            // readOnly={true}
                            isInvalid={
                              formik.touched.valid_until_date && !!formik.errors.valid_until_date
                            }
                          />

                          <Form.Control.Feedback type="invalid">
                            {formik.errors.valid_until_date}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* QUOTATION AUTOCOMPLETE */}
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Quotation Number
                            {/* <span className="text-danger">*</span> */}
                          </Form.Label>

                          <Autocomplete
                            disabled={true}
                            options={
                              Array.isArray(quotationRefenrence)
                                ? quotationRefenrence
                                : []
                            }
                            value={
                              quotationRefenrence.find(
                                (q: any) =>
                                  q.id === formik.values.quotation ||
                                  q.quotation_product_id === formik.values.quotation ||
                                  (q.quotation_number && q.quotation_number === formik.values.quotation_number)
                              ) ||
                              (formik.values.quotation_number && formik.values.quotation ? {
                                id: formik.values.quotation,
                                quotation_number: formik.values.quotation_number,
                                quotation_product_id: formik.values.quotation
                              } : null)
                            }
                            getOptionLabel={(option) =>
                              option.quotation_number ||
                              option.service_quotation_name ||
                              option.product_quotation_name ||
                              ""
                            }
                            isOptionEqualToValue={(option, value) => {
                              if (!option || !value) return false;
                              return (
                                option.id === value.id ||
                                option.quotation_product_id === value.quotation_product_id ||
                                option.quotation_product_id === value.id ||
                                option.id === value.quotation_product_id ||
                                (option.quotation_number && value.quotation_number && option.quotation_number === value.quotation_number)
                              );
                            }}
                            onChange={(_, newValue) => {
                              // Disabled in edit mode - no onChange action
                            }}
                            onBlur={() =>
                              formik.setFieldTouched("quotation", true)
                            }
                            renderInput={(params) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Select Quotation"
                                size="small"
                                disabled={true}
                                error={
                                  formik.touched.quotation &&
                                  !!formik.errors.quotation
                                }
                                helperText={
                                  formik.touched.quotation &&
                                  formik.errors.quotation
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>

                      {/* Enquiry Reference Number */}
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Enquiry Reference Number</Form.Label>

                          <Form.Control
                            type="text"
                            name="enquiry_number"
                            value={formik.values.enquiry_number}
                            disabled
                            isInvalid={
                              formik.touched.enquiry_number &&
                              !!formik.errors.enquiry_number
                            }
                          />

                          <Form.Control.Feedback type="invalid">
                            {formik.errors.enquiry_number}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* Initiated By */}
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Initiated By <span className="text-danger">*</span>
                          </Form.Label>

                          <Form.Control
                            type="text"
                            name="initiated_by"
                            placeholder="Enter Name"
                            value={formik.values.initiated_by}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              formik.touched.initiated_by &&
                              !!formik.errors.initiated_by
                            }
                          />

                          <Form.Control.Feedback type="invalid">
                            {formik.errors.initiated_by}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>


                    </Row>
                  </div>
                </Col>

                {/* Company/Customer Details - RIGHT COLUMN */}
                <Col xs={12} md={6}>
                  <div className="rounded mb-3">
                    <div className="d-flex justify-content-start align-items-center mb-3 gap-2">
                      <h5 className="fw-semibold mb-0 me-1">Customer Details</h5>
                      <Button
                        size="sm"
                        variant="light"
                        className="fw-semibold mb-1 rounded"
                        onClick={() => setShowCompanyModal(true)}
                        disabled={!!(formik.values.quotation || formik.values.quotation_number)}
                        style={{
                          backgroundColor: MecordColors?.LightGrayColor,
                        }}
                      >
                        + Add New Company
                      </Button>
                    </div>

                    <Row
                      className="g-3 pb-3 px-1 rounded"
                      style={{ backgroundColor: MecordColors?.LightThemeBGColor }}
                    >
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>
                            Select Customer <span className="text-danger">*</span>
                          </Form.Label>

                          <Autocomplete
                            disabled={true}
                            options={companies}
                            getOptionLabel={(option) => option.company_name || ""}
                            isOptionEqualToValue={(option, value) => {
                              if (!option || !value) return false;

                              // Get IDs from both option and value, ensuring they're not empty strings
                              const optionCompanyId = option.company_id;
                              const optionId = option.id;
                              const valueCompanyId = value.company_id;
                              const valueId = value.id;

                              // Only compare if IDs are truthy (not empty strings, null, or undefined)
                              // Priority: exact matches first (company_id to company_id, id to id)
                              if (optionCompanyId && valueCompanyId && optionCompanyId === valueCompanyId) {
                                return true;
                              }
                              if (optionId && valueId && optionId === valueId) {
                                return true;
                              }

                              // Cross-match only if exact matches didn't work
                              if (optionCompanyId && valueId && optionCompanyId === valueId) {
                                return true;
                              }
                              if (optionId && valueCompanyId && optionId === valueCompanyId) {
                                return true;
                              }

                              return false;
                            }}
                            value={
                              formik.values.company
                                ? companies.find((c) => {
                                  const formCompanyId = formik.values.company?.company_id;
                                  const formId = formik.values.company?.id;
                                  const cCompanyId = c.company_id;
                                  const cId = c.id;

                                  // Exact matches first
                                  if (formCompanyId && cCompanyId && formCompanyId === cCompanyId) return true;
                                  if (formId && cId && formId === cId) return true;

                                  // Cross-matches
                                  if (formCompanyId && cId && formCompanyId === cId) return true;
                                  if (formId && cCompanyId && formId === cCompanyId) return true;

                                  return false;
                                }) || null
                                : null
                            }

                            onChange={(_, newValue) => {
                              // Disabled in edit mode - no onChange action
                            }}
                            onBlur={() => {
                              formik.setFieldTouched("company_name", true);
                              formik.validateField("company_name");
                            }}
                            renderInput={(params) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Search Customer, Company Name"
                                size="small"
                                disabled={true}
                                error={
                                  formik.touched.company_name &&
                                  !!formik.errors?.company_name
                                }
                                helperText={
                                  formik.touched.company_name &&
                                    formik.errors?.company_name
                                    ? (formik.errors.company_name as string)
                                    : ""
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Industry</Form.Label>
                          <Form.Control
                            type="text"

                            placeholder="Autofill"
                            value={formik?.values?.company?.industry || ""}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>GST Type</Form.Label>
                          <Form.Control
                            type="text"
                            disabled
                            placeholder="Autofill"
                            value={formik?.values?.company?.gst_type || ""}

                          />
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>
                            Contact Person <span className="text-danger">*</span>
                          </Form.Label>
                          {/* Autocomplete for adding contact persons */}
                          <Autocomplete
                            multiple
                            disableCloseOnSelect
                            options={formik.values.company?.contact_details || []}
                            getOptionLabel={(option: any) =>
                              option.contact_person_name ||
                              option.name ||
                              ""
                            }
                            isOptionEqualToValue={(option: any, value: any) => {
                              // Future-safe: use ID when backend starts sending it
                              if (option.id && value.id)
                                return option.id === value.id;

                              // Current workaround: match by email
                              return (
                                option.contact_person_email ===
                                value.contact_person_email
                              );
                            }}
                            value={formik.values.contactPersonArray || []}
                            onChange={(_, newValue: any[]) => {
                              // Remove duplicates using email (currently)
                              const uniqueContacts = newValue.filter(
                                (v, i, a) =>
                                  a.findIndex(
                                    (item) =>
                                      (item.id && v.id && item.id === v.id) || // future ID support
                                      item.contact_person_email ===
                                      v.contact_person_email // current fallback
                                  ) === i
                              );

                              formik.setFieldValue(
                                "contactPersonArray",
                                uniqueContacts
                              );
                            }}
                            onBlur={() =>
                              formik.setFieldTouched("contactPersonArray", true)
                            }
                            renderTags={() => null}
                            ListboxProps={autocompleteDropdownStyles.ListboxProps}
                            renderOption={(props: any, option: any, { selected }: any) => {
                              const { key, ...otherProps } = props;
                              const label =
                                option?.contact_person_name || option?.name || "";

                              return (
                                <li key={key} {...otherProps} style={{ padding: 0 }}>
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      padding: "8px 12px",
                                      backgroundColor: selected
                                        ? MecordColors.ActiveBackground
                                        : "transparent",
                                      color: selected ? MecordColors.ActiveText : "inherit",
                                    }}
                                  >
                                    <span>{label}</span>
                                    {selected && (
                                      <span
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: "10px",
                                          color: "#d32f2f",
                                          fontWeight: "bold",
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();

                                          const current =
                                            formik.values.contactPersonArray || [];

                                          const isSame = (a: any, b: any) => {
                                            if (!a || !b) return false;
                                            // Prefer id match if present
                                            if (a.id && b.id && a.id === b.id) return true;
                                            // Fallback to email match (current behavior)
                                            const aEmail =
                                              a.contact_person_email || a.email || "";
                                            const bEmail =
                                              b.contact_person_email || b.email || "";
                                            return !!(aEmail && bEmail && aEmail === bEmail);
                                          };

                                          const updated = current.filter(
                                            (c: any) => !isSame(option, c)
                                          );

                                          formik.setFieldValue(
                                            "contactPersonArray",
                                            updated
                                          );
                                        }}
                                      >
                                        ✕
                                      </span>
                                    )}
                                  </div>
                                </li>
                              );
                            }}
                            renderInput={(params) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Search Contact Person"
                                size="small"
                                error={
                                  formik.touched.contactPersonArray &&
                                  !!formik.errors.contactPersonArray
                                }
                                helperText={
                                  formik.touched.contactPersonArray &&
                                    typeof formik.errors.contactPersonArray ===
                                    "string"
                                    ? formik.errors.contactPersonArray
                                    : ""
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />

                          {/* Display selected contacts as chips below the input */}
                          <Row>
                            <div className="mt-2 d-flex flex-wrap gap-2">
                              {(formik.values.contactPersonArray || []).map(
                                (contact, index) => {
                                  const contactAny = contact as any;
                                  return (
                                    <div
                                      key={contactAny.id || contactAny.contact_id || index}
                                      className="d-flex align-items-center px-2 py-1 rounded"
                                      style={{
                                        background: MecordColors?.LightThemeBGColor,
                                        border: `1px solid ${MecordColors?.ThemeBGColor}`,
                                        fontSize: "14px",
                                      }}
                                    >
                                      {contact.contact_person_name || contact.name || ""}
                                      <span
                                        style={{
                                          marginLeft: "8px",
                                          cursor: "pointer",
                                          color: "#d32f2f",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => {
                                          // Remove contact by matching id, contact_id, or email
                                          const updated = (formik.values.contactPersonArray || []).filter(
                                            (c: any) => {
                                              // Match by ID if available
                                              if (contactAny.id && c.id && contactAny.id === c.id) return false;
                                              if (contactAny.contact_id && c.contact_id && contactAny.contact_id === c.contact_id) return false;
                                              // Cross-match: contact.id with c.contact_id
                                              if (contactAny.id && c.contact_id && contactAny.id === c.contact_id) return false;
                                              // Cross-match: contact.contact_id with c.id
                                              if (contactAny.contact_id && c.id && contactAny.contact_id === c.id) return false;
                                              // Match by email as fallback
                                              const contactEmail = contactAny.contact_person_email || contactAny.email || "";
                                              const cEmail = c.contact_person_email || c.email || "";
                                              if (contactEmail && cEmail && contactEmail === cEmail) return false;
                                              return true;
                                            }
                                          );
                                          formik.setFieldValue("contactPersonArray", updated);
                                        }}
                                      >
                                        ✕
                                      </span>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </Row>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Customer PO Number
                            {/* <span className="text-danger">*</span> */}
                          </Form.Label>

                          <Form.Control
                            name="customer_po_number"
                            type="text"
                            placeholder="Enter PO Number"
                            value={formik.values.customer_po_number}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              formik.touched.customer_po_number &&
                              !!formik.errors.customer_po_number
                            }
                          />

                          <Form.Control.Feedback type="invalid">
                            {formik.errors.customer_po_number}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            PO Date
                            {/* <span className="text-danger">*</span> */}
                          </Form.Label>

                          <Form.Control
                            name="customer_po_date"
                            type="date"
                            value={formik.values.customer_po_date}
                             
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              formik.touched.customer_po_date &&
                              !!formik.errors.customer_po_date
                            }
                          />

                          <Form.Control.Feedback type="invalid">
                            {formik.errors.customer_po_date}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group>
                          {/* Show selected file + remove button */}
                          <FileUpload
                              label="Upload PO Document"
                              multiple={false}
                              maxFiles={1}
                              value={formik.values.customer_po_document_url}
                              existingFiles={existingPoDocuments}
                              onRemoveExisting={(index) => {
                                setExistingPoDocuments((prev) => {
                                  const updatedDocs = [...prev];
                                  updatedDocs.splice(index, 1);
                                  return updatedDocs;
                                });
                              }}
                              onChange={(files) =>
                                formik.setFieldValue(
                                  "customer_po_document_url",
                                  files
                                )
                              }
                            />

                          <Form.Control.Feedback type="invalid">
                            {formik.errors.customer_po_document_url}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <hr />

              {/* Agent & Members Section */}
              <Row className="mb-4">
                <Col lg={6} md={12}>
                  <h5 className="fw-semibold mb-3">Agent Details</h5>

                  <Form.Group>
                    <Form.Label>Agent Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="agent_name"
                      placeholder="Enter Agent Name"
                      value={formik.values.agent_name || ""}
                      onChange={(e) =>
                        formik.setFieldValue("agent_name", e.target.value)
                      }
                      onBlur={() => formik.setFieldTouched("agent_name", true)}
                      isInvalid={
                        formik.touched.agent_name &&
                        !!formik.errors.agent_name
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.agent_name}
                    </Form.Control.Feedback>
                  </Form.Group>
                  
                </Col>

                <Col lg={6} md={12}>
                  <div className="rounded mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-3 gap-1">
                      <h5 className="fw-semibold">Add Members</h5>
                    </div>

                    <Row
                      className="g-3 pb-3 px-1 rounded mb-2"
                      style={{ backgroundColor: MecordColors?.LightThemeBGColor }}
                    >
                      <Col xs={12} md={12}>
                        <Form.Group>
                          <Form.Label>
                            Assign Members
                            {/* <span className="text-danger">*</span> */}
                          </Form.Label>
                          <Autocomplete
                            options={(membersOptions || []).filter(
                              (user: any) => !selectedMemberIds.includes(user.user_id || user.id)
                            )}
                            getOptionLabel={(option: any) =>
                              `${option.first_name || ""} ${option.last_name || ""}`.trim() || ""
                            }
                            isOptionEqualToValue={(option: any, value: any) =>
                              (option.user_id || option.id) === (value.user_id || value.id)
                            }
                            onChange={(_: any, newValue: any | null) => {
                              if (newValue) {
                                handleMemberAdd(newValue);
                              }
                            }}
                            ListboxProps={autocompleteDropdownStyles.ListboxProps}
                            renderOption={(props, option) =>
                              autocompleteDropdownStyles.renderOption(
                                props,
                                option,
                                (opt) => `${opt.first_name || ""} ${opt.last_name || ""}`.trim() || ""
                              )
                            }
                            renderInput={(params) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Search User"
                                size="small"
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="g-3 rounded">
                      {(formik.values.members || []).length > 0 && (
                        <Col xs={12} md={12}>
                          <div className="d-flex flex-wrap gap-2">
                            {(formik.values.members || []).map((member: any) => (
                              <div
                                key={member.id}
                                className="d-flex align-items-center px-2 py-1 rounded gap-2"
                                style={{
                                  background: MecordColors?.LightThemeBGColor,
                                  border: `1px solid ${MecordColors?.ThemeBGColor}`,
                                  fontSize: "14px",
                                }}
                              >
                                <span
                                  className="rounded-circle d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                    backgroundColor: "#fff",
                                    color: MecordColors.ThemeBGColor,
                                  }}
                                >
                                  {member.initials || getInitials(
                                    member.first_name || "",
                                    member.last_name || ""
                                  )}
                                </span>
                                {member.name ||
                                  (member.first_name && member.last_name
                                    ? `${member.first_name} ${member.last_name}`.trim()
                                    : member.fullname || member.username || member.email || "")}
                                <span
                                  style={{
                                    marginLeft: "4px",
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                  onClick={() => handleMemberRemove(member.id || member.user_id)}
                                >
                                  ✕
                                </span>
                              </div>
                            ))}
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Col>

              </Row>

              <Row className="mt-3">
                <Col md={6}>
                    <AddTagsForSalesOrder
                      value={formik.values.tags || []}
                      onChange={(tags) => formik.setFieldValue("tags", tags)}
                    />
                </Col>
              </Row>

              {/* PBG Details */}
              <hr />
              <Row className="mb-4 g-4">
                <Col lg={12} md={12}>
                  <div className="p-3">
                    <h5 className="mb-3 fw-semibold mb-3" >
                      <Form.Check
                        type="checkbox"
                        label="PBG  (Performance Bank Guarantee) Details"
                        name="pbg_details.pbg_required"
                        checked={formik.values.pbg_details.pbg_required}
                        onChange={formik.handleChange}
                      />
                    </h5>


                    {formik.values.pbg_details.pbg_required && (
                      <>
                        <Row className="mb-3">
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                PBG Number{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="pbg_details.pbg_number"
                                placeholder="Enter PBG Number"
                                value={formik.values.pbg_details.pbg_number}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.pbg_number &&
                                  formik.touched.pbg_details?.pbg_number
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.touched.pbg_details?.pbg_number &&
                                  formik.errors.pbg_details?.pbg_number}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                PBG Date
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="date"
                                name="pbg_details.pbg_date"
                                value={formatDateForInput(formik.values.pbg_details.pbg_date)}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.pbg_date &&
                                  formik.touched.pbg_details?.pbg_date
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.touched.pbg_details?.pbg_date &&
                                  formik.errors.pbg_details?.pbg_date}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                Bank Name{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="pbg_details.bank_name"
                                placeholder="Enter Bank Name"
                                value={formik.values.pbg_details.bank_name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.bank_name &&
                                  formik.touched.pbg_details?.bank_name
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.pbg_details?.bank_name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                Amount{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="number"
                                name="pbg_details.amount"
                                min="0"
                                value={formik.values.pbg_details.amount}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.amount &&
                                  formik.touched.pbg_details?.amount
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.pbg_details?.amount}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                Validity{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="date"
                                name="pbg_details.validity"
                                value={formatDateForInput(formik.values.pbg_details.validity)}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.validity &&
                                  formik.touched.pbg_details?.validity
                                }
                                placeholder="e.g., 12 months"
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.pbg_details?.validity}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                PBG Status{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Autocomplete
                                options={pbgStatusOptions}
                                value={formik.values.pbg_details.pbg_status || null}
                                onChange={(_, newValue) => {
                                  formik.setFieldValue("pbg_details.pbg_status", newValue || "");
                                }}
                                onBlur={() => {
                                  formik.setFieldTouched("pbg_details.pbg_status", true);
                                }}
                                ListboxProps={autocompleteDropdownStyles.ListboxProps}
                                renderOption={(props, option) =>
                                  autocompleteDropdownStyles.renderOption(
                                    props,
                                    option,
                                    (option: any) => option || ""
                                  )
                                }
                                renderInput={(params) => (
                                  <BootstrapTextField
                                    {...params}
                                    placeholder="Select Status"
                                    size="small"
                                    error={
                                      !!formik.errors.pbg_details?.pbg_status &&
                                      formik.touched.pbg_details?.pbg_status
                                    }
                                    helperText={
                                      formik.touched.pbg_details?.pbg_status &&
                                      formik.errors.pbg_details?.pbg_status
                                    }
                                    sx={autocompleteDropdownStyles.inputSx}
                                  />
                                )}
                              />
                            </Form.Group>
                          </Col>

                          <Col md={3}>
                            <FileUpload
                              label="Upload Document"
                              multiple
                              maxFiles={1}
                              value={formik.values.pbg_details.upload_document}
                              existingFiles={existingPbgDocuments}
                              onRemoveExisting={(index) => {
                                setExistingPbgDocuments((prev) => {
                                  const updatedDocs = [...prev];
                                  updatedDocs.splice(index, 1);
                                  return updatedDocs;
                                });
                              }}
                              onChange={(files) =>
                                formik.setFieldValue(
                                  "pbg_details.upload_document",
                                  files
                                )
                              }
                            />
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>PBG Follow Up Date</Form.Label>
                              <Form.Control
                                type="date"
                                name="pbg_details.next_follow_up_date"
                                value={(formik.values.pbg_details as any)?.next_follow_up_date || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}

                  </div>
                </Col>
              </Row>

              <hr />

              {/* Currency & EMD Details */}
              <Row className="mb-3 ">
                {/* Currency Code */}
                <Col lg={6} md={12}>
                  <h5 className="fw-semibold mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Currency & Exchange Details"
                      name="currency_applicable"
                      checked={formik.values.currency_applicable}
                      onChange={(e: any) => {
                        formik.handleChange(e);
                        if (!e.target.checked) {
                          formik.setFieldValue("currency_code", "INR");
                          formik.setFieldValue("currency_symbol", "₹");
                          formik.setFieldValue("exchange_rate", "1");
                          formik.setFieldValue("composition_gst", false);
                          formik.setFieldValue("select_composition_gst", "");
                        }
                      }}
                    />
                  </h5>

                  {formik.values.currency_applicable && (
                    <CurrencyExchangeSection
                      formik={formik}
                      setItems={setItems}
                      currencyList={currencyList || []}
                      onExchangeChange={(value) => setTableExchange(value)}
                    />
                  )}
                </Col>

                <Col lg={6} md={12}>

                  <h5 className="fw-semibold mb-3">
                    <Form.Check
                      type="checkbox"
                      label="EMD (Earnest Money Deposit) Details"
                      name="emd_applicable"
                      checked={formik.values.emd_applicable}
                      onChange={(e: any) => {
                        formik.handleChange(e);
                        if (!e.target.checked) {
                          formik.setFieldValue("mode_of_emd", "");
                          formik.setFieldValue("emd_amount", "");
                        }
                      }}
                    />
                  </h5>

                  {formik.values.emd_applicable && (
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Mode of EMD
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Autocomplete
                            options={["BG", "DD", "NEFT/RTGS"]}
                            getOptionLabel={(option: any) => option}
                            value={formik.values.mode_of_emd || null}
                            onChange={(_: any, newValue: any) => {
                              formik.setFieldValue("mode_of_emd", newValue || "");
                              if (!newValue) {
                                formik.setFieldValue("emd_amount", "");
                              }
                            }}
                            onBlur={() => formik.setFieldTouched("mode_of_emd", true)}
                            ListboxProps={autocompleteDropdownStyles.ListboxProps}
                            renderInput={(params: any) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Select Mode of EMD"
                                size="small"
                                error={
                                  formik.touched.mode_of_emd &&
                                  Boolean(formik.errors.mode_of_emd)
                                }
                                helperText={
                                  formik.touched.mode_of_emd &&
                                    typeof formik.errors.mode_of_emd === "string"
                                    ? formik.errors.mode_of_emd
                                    : ""
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            EMD Amount
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="emd_amount"
                            min="0"
                            value={formik.values.emd_amount || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              !!formik.errors.emd_amount &&
                              formik.touched.emd_amount
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.emd_amount}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                </Col>

              </Row>

              <hr />

              <Row>
                <Col lg={12}>
                  <h5 className="fw-semibold mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Inspection & Installation Details"
                      name="inspection_applicable"
                      checked={formik.values.inspection_applicable}
                      onChange={(e: any) => {
                        formik.handleChange(e);
                        if (!e.target.checked) {
                          formik.setFieldValue("inspection", "");
                          formik.setFieldValue("inspection_date", "");
                          formik.setFieldValue("installation", "");
                          formik.setFieldValue("installation_date", "");
                        }
                      }}
                    />
                  </h5>

                  {formik.values.inspection_applicable && (
                    <Row className="g-3">
                      <Col lg={3} md={6}>
                        <Form.Group className="mb-4">
                          <Form.Label>
                            Inspection<span className="text-danger">*</span>
                          </Form.Label>
                          <Autocomplete
                            options={["Applicable", "Not Applicable"]}
                            getOptionLabel={(option: any) => option}
                            isOptionEqualToValue={(option: any, value: any) =>
                              option === value
                            }
                            value={formik.values.inspection || null}
                            onChange={(_: any, newValue: any) => {
                              formik.setFieldValue("inspection", newValue || "");
                              formik.setFieldValue("inspection_date", "");
                              formik.setFieldTouched("inspection", false);
                              formik.setFieldTouched("inspection_date", false);
                            }}
                            onBlur={() => {
                              formik.setFieldTouched("inspection", true);
                              formik.validateField("inspection");
                            }}
                            ListboxProps={autocompleteDropdownStyles.ListboxProps}
                            renderOption={(props, option) =>
                              autocompleteDropdownStyles.renderOption(
                                props,
                                option,
                                (opt) => opt || ""
                              )
                            }
                            renderInput={(params: any) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Select"
                                size="small"
                                error={
                                  !!formik.errors.inspection &&
                                  formik.touched.inspection
                                }
                                helperText={
                                  formik.errors.inspection &&
                                    formik.touched.inspection
                                    ? formik.errors.inspection
                                    : ""
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={3} md={6}>
                        <Form.Group>
                          <Form.Label>
                            Inspection Date{" "}
                            {formik?.values?.inspection === "Applicable" && (
                              <span className="text-danger">*</span>
                            )}
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="inspection_date"
                            value={formatDateForInput(formik.values.inspection_date)}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            // readOnly={true}
                            isInvalid={
                              !!(
                                formik.errors.inspection_date &&
                                formik.touched.inspection_date
                              )
                            }
                          />
                          {formik.errors.inspection_date &&
                            formik.touched.inspection_date && (
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.inspection_date as string}
                              </Form.Control.Feedback>
                            )}
                        </Form.Group>
                      </Col>




                      <Col lg={3} md={6}>
                        <Form.Group className="mb-4">
                          <Form.Label>
                            Installation<span className="text-danger">*</span>
                          </Form.Label>
                          <Autocomplete
                            options={["Applicable", "Not Applicable"]}
                            getOptionLabel={(option: any) => option}
                            isOptionEqualToValue={(option: any, value: any) =>
                              option === value
                            }
                            value={formik.values.installation || null}
                            onChange={(_: any, newValue: any) => {
                              formik.setFieldValue("installation", newValue || "");
                              formik.setFieldValue("installation_date", "");
                              formik.setFieldTouched("installation", false);
                              formik.setFieldTouched("installation_date", false);
                            }}
                            onBlur={() => {
                              formik.setFieldTouched("installation", true);
                              formik.validateField("installation");
                            }}
                            ListboxProps={autocompleteDropdownStyles.ListboxProps}
                            renderOption={(props, option) =>
                              autocompleteDropdownStyles.renderOption(
                                props,
                                option,
                                (opt) => opt || ""
                              )
                            }
                            renderInput={(params: any) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Select"
                                size="small"
                                error={
                                  !!formik.errors.installation &&
                                  formik.touched.installation
                                }
                                helperText={
                                  formik.errors.installation &&
                                    formik.touched.installation
                                    ? formik.errors.installation
                                    : ""
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={3} md={6}>
                        <Form.Group>
                          <Form.Label>
                            Installation Date
                            {formik?.values?.installation === "Applicable" && (
                              <span className="text-danger">*</span>
                            )}
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="installation_date"
                            value={formatDateForInput(formik.values.installation_date)}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            // readOnly={true}
                            isInvalid={
                              !!(
                                formik.errors.installation_date &&
                                formik.touched.installation_date
                              )
                            }
                          />
                          {formik.errors.installation_date &&
                            formik.touched.installation_date && (
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.installation_date as string}
                              </Form.Control.Feedback>
                            )}
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>

              <hr />

              {/* Billing address section */}
              <Row>
                {/* BILLING FROM */}
                <h5 className="fw-semibold mb-3">Billing & Service Details</h5>
                <div
                  className="p-3 rounded mb-3"
                  style={{ backgroundColor: MecordColors.ActiveBackground }}
                >
                  <Row>
                    <Col lg={6} md={12}>
                      <BillingFromAddress
                        value={formik.values.bill_from_address}
                        onChange={async (newValue) => {
                          await formik.setFieldValue("bill_from_address", newValue);
                          formik.setFieldTouched("bill_from_address", true);
                          // Validate the field after setting the value
                          await formik.validateField("bill_from_address");
                        }}
                        onBlur={async () => {
                          formik.setFieldTouched("bill_from_address", true);
                          await formik.validateField("bill_from_address");
                        }}
                        error={
                          formik.touched.bill_from_address
                            ? formik.errors.bill_from_address || undefined
                            : undefined
                        }
                      />
                    </Col>

                    {/* BILLING TO – OPTIONAL */}
                    <Col lg={6} md={12}>
                      <Form.Group>
                        <Form.Label >Bill to</Form.Label>

                        <Tooltip
                          title={formatFullAddress(formik.values.billing_address) || "No address available"}
                          arrow
                          placement="top"
                        >
                          <Form.Control
                            type="text"
                            name="billing_address.address"
                            placeholder="Autofill"
                            value={formatFullAddress(formik.values.billing_address) || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              formik.touched.billing_address &&
                              !!formik.errors.billing_address
                            }
                            disabled
                            style={{
                              cursor: "pointer",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}
                          />
                        </Tooltip>

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.bill_to_address}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Row>
              <hr />


              {/* Product List Section - id for scroll when "at least one product" required */}
              <Row className="mb-3" id="items">
                <Col md={12}>
                  <div className="d-flex justify-content-start align-items-center mb-2">
                    <h5 className="fw-semibold mb-0">Product </h5>
                    <Button
                      size="sm"
                      variant="light"
                      className="fw-semibold ms-3"
                      onClick={() => setShowProductModal(true)}
                      style={{
                        backgroundColor: MecordColors?.LightGrayColor,
                        color: "#000",
                      }}
                    >
                      + Add New Product
                    </Button>
                  </div>
                  <ProductAndServiceSection

                    items={items as any[]}

                    setItems={setItems as React.Dispatch<React.SetStateAction<any[]>>}
                    //   categories={categories}
                    //   subcategories={subcategories}
                    //   makes={makes}
                    //   models={models}
                    //   fetchSubcategories={(categoryId) => dispatch(fetchCategories("products"))}
                    //   fetchMakes={(params) => dispatch(fetchMakes(params))}
                    //   fetchModels={(params) => dispatch(fetchModels(params))}
                    //   products={{}}
                    onAdd={handleProductAdd}
                    billFromAddress={formik.values.bill_from_address}
                    shippingAddresses={shippingAddresses}
                    composition_gst={formik.values.composition_gst}
                    select_composition_gst={formik.values.select_composition_gst}
                    currency_code={formik.values.currency_code}
                    currency_symbol={formik.values.currency_symbol}
                    exchange_rate={formik.values.exchange_rate}
                    company_gst_type={formik.values.company?.gst_type}
                    billToAddress={formik.values.billing_address}
                    setShowAddressModal={setShowAddressModal}
                    setShowProductModal={setShowProductModal}
                    ref={productFormRef}
                  />
                </Col>
              </Row>

              {/* Totals Section */}

              <div className="row g-3 align-items-start">
                {/* LEFT SIDE - TERMS & CONDITIONS */}
                <Col lg={6} md={12}>

                  <FormikProvider value={formik}>
                    <TermsConditionsSection />
                  </FormikProvider>
                  <Form.Group className="mt-3">
                    <Form.Label>Payment Terms Amount</Form.Label>
                    <Form.Control
                      type="number"
                      name="payment_terms_amount"
                      placeholder="Enter Payment Terms Amount"
                      value={formik.values.payment_terms_amount ?? ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={formik.touched.payment_terms_amount && !!formik.errors.payment_terms_amount}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.payment_terms_amount}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                {/* RIGHT SIDE - TOTAL SUMMARY */}
                <Col lg={6} md={12}>
                  <div className="">
                    <h5 className="fw-semibold mb-3">Total Summary</h5>

                    <div className="rounded p-3" style={{ backgroundColor: MecordColors.LightThemeBGColor }}>
                      <Row className="mb-2">
                        <Col xs={8}>
                          <span>Subtotal (Before Discount):</span>
                        </Col>
                        <Col xs={4} className="text-end">
                          <strong>
                            {formik.values.currency_symbol || (formik.values.currency_code === "INR" || formik.values.currency_code === "IND" ? "₹" : "@")}
                            {formatIndianAmount(totals.subTotal || 0)}
                          </strong>
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col xs={8}>
                          <span>Total Item Discounts:</span>
                        </Col>
                        <Col xs={4} className="text-end">
                          <strong>
                            {formik.values.currency_symbol || (formik.values.currency_code === "INR" || formik.values.currency_code === "IND" ? "₹" : "@")}
                            {formatIndianAmount(totals.discount || 0)}
                          </strong>
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col xs={8}>
                          <span>Net Total:</span>
                        </Col>
                        <Col xs={4} className="text-end">
                          <strong>
                            {formik.values.currency_symbol || (formik.values.currency_code === "INR" || formik.values.currency_code === "IND" ? "₹" : "@")}
                            {formatIndianAmount(totals.netTotal || 0)}
                          </strong>
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col xs={8}>
                          <span>Total GST Value:</span>
                        </Col>
                        <Col xs={4} className="text-end">
                          <strong>
                            {formik.values.currency_symbol || (formik.values.currency_code === "INR" || formik.values.currency_code === "IND" ? "₹" : "@")}
                            {formatIndianAmount(totals.gst || 0)}
                          </strong>
                        </Col>
                      </Row>
                      <hr />
                      <Row>
                        <Col xs={8}>
                          <span className="fw-bold">Total Amount:</span>
                        </Col>
                        <Col xs={4} className="text-end">
                          <strong className="fw-bold" style={{ fontSize: "1.2rem" }}>
                            {formik.values.currency_symbol || (formik.values.currency_code === "INR" || formik.values.currency_code === "IND" ? "₹" : "@")}
                            {formatIndianAmount(totals.grandTotal || 0)}
                          </strong>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </div>

              <hr />

              {/* Retention + Notes/Attachments + Schedule Follow-up */}
              <Row className="">
                <Col md={12}>
                  <RetentionDetails
                    value={formik.values.retention_details}
                    onChange={(newValue) =>
                      formik.setFieldValue("retention_details", newValue)
                    }
                    error={
                      formik.touched.retention_details
                        ? formik.errors.retention_details || undefined
                        : undefined
                    }
                    retentionTypeOptions={retentionTypeOptions}
                    baseAmount={totals.netTotal}
                    disabled={saving || savingDraft}
                  />
                </Col>
              </Row>

              <hr />

              <Row className="g-3 mt-2">
                <Col md={6}>
                  <div className="d-flex justify-content-between align-items-center mb-1 gap-2">
                    <h5 className="fw-semibold">Notes & Attachments</h5>
                  </div>

                  <div
                    className="rounded mb-3"
                    style={{ backgroundColor: MecordColors?.LightGrayColor }}
                  >
                    <Form.Group>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="notes"
                        placeholder="Enter your notes"
                        value={formik.values.notes || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        style={{ maxHeight: "400px", resize: "vertical" }}
                        isInvalid={
                          formik.touched.notes && !!formik.errors.notes
                        }
                      />

                      <Form.Control.Feedback type="invalid">
                        {formik.touched.notes && formik.errors.notes}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>

                  <div>
                    <h6 className="fw-semibold mb-2">Attach Files</h6>

                    <Form.Group>
                      <FileUpload
                        label=""
                        multiple={true}
                        value={formik.values.attachments} // 👈 NEW FILES ONLY
                        existingFiles={existingDocuments} // 👈 EXISTING DOCS
                        onChange={(files) =>
                          formik.setFieldValue("attachments", files)
                        }
                        onRemoveExisting={(index) => {
                          const updatedDocs = [...existingDocuments];
                          updatedDocs.splice(index, 1);
                          setExistingDocuments(updatedDocs);
                        }}
                      />
                    </Form.Group>
                  </div>
                </Col>

              </Row>

              {/* Footer Buttons */}

              <Row className="mt-3">
                <Col className="d-flex justify-content-center">
                  <FormActionButtons
                    onCancel={() => navigate(getBackPath())}
                    onSave={async () => {
                      const fields = Object.keys(formik.values);
                      const touchedFields: any = {};
                      fields.forEach((field) => {
                        touchedFields[field] = true;
                      });
                      formik.setTouched(touchedFields);
                      const errors = await formik.validateForm();
                      if (Object.keys(errors).length > 0) {
                        formik.setErrors(errors);
                        setValidationAttemptCount((c) => c + 1);
                        const firstError = Object.values(errors).find((err: any) =>
                          typeof err === "string" && err.trim() !== ""
                        ) || "Please fix the validation errors";
                        if (typeof firstError === "string") {
                          toast.error(firstError);
                        }
                        return;
                      }
                      if (!items || items.length === 0) {
                        toast.error("At least one product is required");
                        setTimeout(() => document.getElementById("items")?.scrollIntoView({ behavior: "smooth", block: "center" }), 100);
                        return;
                      }
                      try {
                        await handleSubmitAction(formik.values, "save");
                        // toast.success("Sales order saved successfully");
                        navigate(getBackPath());
                      } catch (err) {
                        // Error already handled in handleSubmitAction with toast
                      }
                    }}
                    showSaveDraft={false}
                    isSaving={saving}
                    isSavingDraft={savingDraft}
                    wrapperClassName="d-flex flex-wrap justify-content-center gap-3"
                  />
                </Col>
              </Row>
            </Form>
          </>
        )}

        {/* <Modal.Header
              closeButton
              style={{
                backgroundColor: MecordColors?.ThemeBGColor,
                paddingBottom: "20px",
              }}
            >
              <Modal.Title style={{ color: "#fff" }}>
                Add New Customer
              </Modal.Title>
            </Modal.Header> */}

        <AddCustomerModal
          show={showCompanyModal}
          onHide={() => setShowCompanyModal(false)}
          onSave={async () => {
            await dispatch(fetchCompanyByDropDown());
          }}
        />


        {true ? (
          <AddProductModal
            show={showProductModal}
            onHide={() => setShowProductModal(false)}
            onSave={async () => {
              await dispatch(fetchCategories("products"));
            }}
          />
        ) : (
          <Modal
            show={showServiceModal}
            onHide={() => setShowServiceModal(false)}
            backdrop="static"
            keyboard={false}
            size="xl"
            centered
          >
            <Modal.Header
              closeButton
              style={{
                backgroundColor: MecordColors?.ThemeBGColor,
                paddingBottom: "20px",
              }}
            >
              <Modal.Title style={{ color: "#fff" }}>
                Add New Service
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
              <ServiceFormModal
                onSuccess={async () => {
                  await dispatch(fetchCategories("services"));
                  setShowServiceModal(false);
                }}
                onCancel={() => setShowServiceModal(false)}
              />
            </Modal.Body>
          </Modal>
        )}
        <Modal
          show={showAddressModal}
          onHide={() => setShowAddressModal(false)}
          backdrop="static"
          keyboard={false}
          size="xl"
          centered
        >
          <Modal.Header
            closeButton
            style={{
              backgroundColor: MecordColors?.ThemeBGColor,
              paddingBottom: "20px",
            }}
          >
            <Modal.Title style={{ color: "#fff" }}>
              Add New Address
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            {formik.values.company && (
              <AddressFormModal
                company_id={formik.values.company?.company_id || formik.values.company?.id}
                formik={formik}
                onSuccess={async (response: any) => {
                  // Only refetch company dropdown, don't refresh the page
                  const companiesResult = await dispatch(fetchCompanyByDropDown()).unwrap();
                  const updatedCompanies = companiesResult?.data || companiesResult || [];

                  // Update local companies state
                  setCompanies(updatedCompanies);

                  // Find the updated company with new shipping addresses
                  const currentCompanyId = formik.values.company?.company_id || formik.values.company?.id;
                  const updatedCompany = updatedCompanies.find(
                    (c: any) => c.id === currentCompanyId || c.company_id === currentCompanyId
                  );

                  // Update company object in formik with new shipping addresses
                  if (updatedCompany && updatedCompany.shipping_addresses) {
                    // Store previous address count and IDs BEFORE updating (to identify the new address)
                    const previousAddressCount = formik.values.company?.shipping_addresses?.length || 0;
                    const previousAddressIds = new Set(
                      (formik.values.company?.shipping_addresses || []).map((addr: any) =>
                        addr.id || addr.shipping_address_id
                      ).filter(Boolean)
                    );

                    const formattedAddresses = updatedCompany.shipping_addresses.map(
                      (addr: any) => ({
                        id: addr.id || addr.shipping_address_id,
                        address: addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
                        state: addr.state,
                        city: addr.city,
                        pin_code: addr.pincode || addr.pin_code,
                        phone_number: addr.phone_number,
                      })
                    );

                    // Update shipping addresses state
                    setShippingAddresses(formattedAddresses);

                    // Update company object in formik
                    formik.setFieldValue("company", {
                      ...formik.values.company,
                      shipping_addresses: updatedCompany.shipping_addresses,
                    }, false);

                    // console.log("response => in productsalesordereditform add shipping address", response)
                    // Directly set the newly added address in DynamicProductAndServiceForm (like quotation form)
                    if (response && response.data && productFormRef.current) {
                      // Get the newly created address from response (response.data.data.createdAddress)
                      const newAddress = response.data?.data?.createdAddress || response.data?.createdAddress || response.data;
                      // console.log("newAddress => in productsalesordereditform add shipping address", newAddress)

                      // The newAddress from response is the most reliable source - use it directly
                      // Extract the ID to verify it exists in updatedCompany
                      const newAddressId = newAddress?.shipping_address_id || newAddress?.id;
                      // console.log("newAddressId => in productsalesordereditform add shipping address", newAddressId)

                      let fullNewAddress = newAddress; // Default to using the response address directly

                      // Try to find the matching address in updatedCompany to get the full object structure
                      // This ensures we have all fields that might be in the company's address list
                      if (newAddressId && updatedCompany.shipping_addresses && updatedCompany.shipping_addresses.length > 0) {
                        // console.log("updatedCompany.shipping_addresses => in productsalesordereditform add shipping address", updatedCompany.shipping_addresses)

                        // Find the address with matching ID - use strict comparison
                        const foundAddress = updatedCompany.shipping_addresses.find(
                          (addr: any) => {
                            const addrShippingId = addr.shipping_address_id || addr.id;
                            const addrId = addr.id;

                            // Strict match: both IDs must be defined and match exactly
                            return (newAddressId && addrShippingId && addrShippingId === newAddressId) ||
                              (newAddressId && addrId && addrId === newAddressId);
                          }
                        );

                        // Only use foundAddress if it actually matches (has the same ID)
                        if (foundAddress) {
                          const foundId = foundAddress.shipping_address_id || foundAddress.id;
                          if (foundId === newAddressId) {
                            fullNewAddress = foundAddress;
                            // console.log("fullNewAddress found by ID match => in productsalesordereditform add shipping address", fullNewAddress)
                          } else {
                            // console.log("Found address but ID mismatch, using newAddress from response")
                          }
                        } else {
                          // console.log("Address not found in updatedCompany, using newAddress from response")
                        }
                      }

                      // Final fallback: if we still don't have a match and count increased, use the last address
                      if (!fullNewAddress || (fullNewAddress !== newAddress && updatedCompany.shipping_addresses && updatedCompany.shipping_addresses.length > previousAddressCount)) {
                        const lastAddress = updatedCompany.shipping_addresses[updatedCompany.shipping_addresses.length - 1];
                        const lastAddressId = lastAddress?.shipping_address_id || lastAddress?.id;
                        // Only use last address if its ID matches the new address ID
                        if (lastAddressId === newAddressId) {
                          fullNewAddress = lastAddress;
                          // console.log("fullNewAddress using last address (ID matched) => in productsalesordereditform add shipping address", fullNewAddress)
                        }
                      }

                      // console.log("final fullNewAddress => in productsalesordereditform add shipping address", fullNewAddress)

                      // Wait a bit for shippingAddressOptions to update, then call the method
                      setTimeout(() => {
                        if (productFormRef.current?.setShippingAddress && fullNewAddress) {
                          productFormRef.current.setShippingAddress(fullNewAddress);
                        }
                      }, 100);
                    }
                  }

                  setShowAddressModal(false);
                }}
                onCancel={() => setShowAddressModal(false)}
              />
            )}
          </Modal.Body>
        </Modal>
      </PageContainer>
    </>
  );
};




export default ProductSalesOrderEditForm;
